var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRules(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 315,
    height: 199,
    viewBox: "0 0 315 199",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1420_6457)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.646484,
    y: 0.270508,
    width: 314,
    height: 198,
    rx: 16,
    fill: "#EDF6FF"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_1420_6457)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_1420_6457)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 22.1209,
    cy: 14.4422,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 29.1512,
    cy: 14.4422,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 36.1815,
    cy: 14.4422,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 43.2127,
    cy: 14.4422,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 50.2459,
    cy: 14.4422,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 57.2723,
    cy: 14.4422,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 64.3104,
    cy: 14.4422,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 71.3377,
    cy: 14.4422,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 78.3641,
    cy: 14.4422,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 85.3934,
    cy: 14.4422,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 92.4237,
    cy: 14.4422,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 99.4559,
    cy: 14.4422,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 106.482,
    cy: 14.4422,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 113.514,
    cy: 14.4422,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 120.545,
    cy: 14.4422,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 127.58,
    cy: 14.4422,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 134.604,
    cy: 14.4422,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 141.628,
    cy: 14.4422,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 148.672,
    cy: 14.4422,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 155.692,
    cy: 14.4422,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 162.725,
    cy: 14.4422,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 169.755,
    cy: 14.4422,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 176.787,
    cy: 14.4422,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 183.82,
    cy: 14.4422,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 190.844,
    cy: 14.4422,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 197.873,
    cy: 14.4422,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 204.9,
    cy: 14.4422,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 211.938,
    cy: 14.4422,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 218.968,
    cy: 14.4422,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 226.004,
    cy: 14.4422,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 233.03,
    cy: 14.4422,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 240.058,
    cy: 14.4422,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 247.089,
    cy: 14.4422,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 254.116,
    cy: 14.4422,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 261.145,
    cy: 14.4422,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 268.18,
    cy: 14.4422,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 275.211,
    cy: 14.4422,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 282.24,
    cy: 14.4422,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 289.269,
    cy: 14.4422,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip3_1420_6457)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 22.1219,
    cy: 21.4742,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 29.1512,
    cy: 21.4742,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 36.1815,
    cy: 21.4742,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 43.2137,
    cy: 21.4742,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 50.2459,
    cy: 21.4742,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 57.2723,
    cy: 21.4742,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 64.3104,
    cy: 21.4742,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 71.3367,
    cy: 21.4742,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 78.3641,
    cy: 21.4742,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 85.3934,
    cy: 21.4742,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 92.4237,
    cy: 21.4742,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 99.4559,
    cy: 21.4742,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 106.482,
    cy: 21.4742,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 113.514,
    cy: 21.4742,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 120.545,
    cy: 21.4742,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 127.581,
    cy: 21.4742,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 134.604,
    cy: 21.4742,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 141.628,
    cy: 21.4742,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 148.672,
    cy: 21.4742,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 155.693,
    cy: 21.4742,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 162.725,
    cy: 21.4742,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 169.755,
    cy: 21.4742,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 176.788,
    cy: 21.4742,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 183.82,
    cy: 21.4742,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 190.844,
    cy: 21.4742,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 197.874,
    cy: 21.4742,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 204.9,
    cy: 21.4742,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 211.938,
    cy: 21.4742,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 218.968,
    cy: 21.4742,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 226.004,
    cy: 21.4742,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 233.03,
    cy: 21.4742,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 240.059,
    cy: 21.4742,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 247.09,
    cy: 21.4742,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 254.116,
    cy: 21.4742,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 261.145,
    cy: 21.4742,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 268.181,
    cy: 21.4742,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 275.211,
    cy: 21.4742,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 282.24,
    cy: 21.4742,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 289.269,
    cy: 21.4742,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip4_1420_6457)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 22.1219,
    cy: 28.5025,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 29.1512,
    cy: 28.5025,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 36.1815,
    cy: 28.5025,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 43.2137,
    cy: 28.5025,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 50.2459,
    cy: 28.5025,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 57.2723,
    cy: 28.5025,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 64.3104,
    cy: 28.5025,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 71.3367,
    cy: 28.5025,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 78.3641,
    cy: 28.5025,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 85.3934,
    cy: 28.5025,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 92.4237,
    cy: 28.5025,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 99.4559,
    cy: 28.5025,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 106.482,
    cy: 28.5025,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 113.514,
    cy: 28.5025,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 120.545,
    cy: 28.5025,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 127.581,
    cy: 28.5025,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 134.604,
    cy: 28.5025,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 141.628,
    cy: 28.5025,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 148.672,
    cy: 28.5025,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 155.693,
    cy: 28.5025,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 162.725,
    cy: 28.5025,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 169.755,
    cy: 28.5025,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 176.788,
    cy: 28.5025,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 183.82,
    cy: 28.5025,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 190.844,
    cy: 28.5025,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 197.874,
    cy: 28.5025,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 204.9,
    cy: 28.5025,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 211.938,
    cy: 28.5025,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 218.968,
    cy: 28.5025,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 226.004,
    cy: 28.5025,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 233.03,
    cy: 28.5025,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 240.059,
    cy: 28.5025,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 247.09,
    cy: 28.5025,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 254.116,
    cy: 28.5025,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 261.145,
    cy: 28.5025,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 268.181,
    cy: 28.5025,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 275.211,
    cy: 28.5025,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 282.24,
    cy: 28.5025,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 289.269,
    cy: 28.5025,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip5_1420_6457)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 22.1219,
    cy: 35.5345,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 29.1512,
    cy: 35.5345,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 36.1815,
    cy: 35.5343,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 43.2137,
    cy: 35.5343,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 50.2459,
    cy: 35.5343,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 57.2723,
    cy: 35.5343,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 64.3104,
    cy: 35.5345,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 71.3367,
    cy: 35.5345,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 78.3641,
    cy: 35.5345,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 85.3934,
    cy: 35.5345,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 92.4237,
    cy: 35.5345,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 99.4559,
    cy: 35.5345,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 106.482,
    cy: 35.5345,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 113.514,
    cy: 35.5345,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 120.545,
    cy: 35.5345,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 127.581,
    cy: 35.5343,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 134.604,
    cy: 35.5343,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 141.628,
    cy: 35.5343,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 148.672,
    cy: 35.5345,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 155.693,
    cy: 35.5345,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 162.725,
    cy: 35.5345,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 169.755,
    cy: 35.5345,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 176.788,
    cy: 35.5345,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 183.82,
    cy: 35.5345,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 190.844,
    cy: 35.5345,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 197.874,
    cy: 35.5345,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 204.9,
    cy: 35.5345,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 211.938,
    cy: 35.5345,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 218.968,
    cy: 35.5345,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 226.004,
    cy: 35.5343,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 233.03,
    cy: 35.5343,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 240.059,
    cy: 35.5343,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 247.09,
    cy: 35.5345,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 254.116,
    cy: 35.5345,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 261.145,
    cy: 35.5345,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 268.181,
    cy: 35.5345,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 275.211,
    cy: 35.5345,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 282.24,
    cy: 35.5345,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 289.269,
    cy: 35.5345,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip6_1420_6457)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 22.1219,
    cy: 42.5635,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 29.1512,
    cy: 42.5635,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 36.1815,
    cy: 42.5635,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 43.2137,
    cy: 42.5635,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 50.2459,
    cy: 42.5635,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 57.2723,
    cy: 42.5635,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 64.3104,
    cy: 42.5635,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 71.3367,
    cy: 42.5635,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 78.3641,
    cy: 42.5635,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 85.3934,
    cy: 42.5635,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 92.4237,
    cy: 42.5635,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 99.4559,
    cy: 42.5635,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 106.482,
    cy: 42.5635,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 113.514,
    cy: 42.5635,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 120.545,
    cy: 42.5635,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 127.581,
    cy: 42.5635,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 134.604,
    cy: 42.5635,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 141.628,
    cy: 42.5635,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 148.672,
    cy: 42.5635,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 155.693,
    cy: 42.5635,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 162.725,
    cy: 42.5635,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 169.755,
    cy: 42.5635,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 176.788,
    cy: 42.5635,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 183.82,
    cy: 42.5635,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 190.844,
    cy: 42.5635,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 197.874,
    cy: 42.5635,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 204.9,
    cy: 42.5635,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 211.938,
    cy: 42.5635,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 218.968,
    cy: 42.5635,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 226.004,
    cy: 42.5635,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 233.03,
    cy: 42.5635,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 240.059,
    cy: 42.5635,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 247.09,
    cy: 42.5635,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 254.116,
    cy: 42.5635,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 261.145,
    cy: 42.5635,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 268.181,
    cy: 42.5635,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 275.211,
    cy: 42.5635,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 282.24,
    cy: 42.5635,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 289.269,
    cy: 42.5635,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip7_1420_6457)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 22.1219,
    cy: 49.5941,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 29.1512,
    cy: 49.5943,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 36.1815,
    cy: 49.5938,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 43.2137,
    cy: 49.5938,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 50.2459,
    cy: 49.5938,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 57.2723,
    cy: 49.5938,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 64.3104,
    cy: 49.5943,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 71.3367,
    cy: 49.5943,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 78.3641,
    cy: 49.5943,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 85.3934,
    cy: 49.5943,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 92.4237,
    cy: 49.5943,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 99.4559,
    cy: 49.5943,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 106.482,
    cy: 49.5943,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 113.514,
    cy: 49.5943,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 120.545,
    cy: 49.5943,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 127.581,
    cy: 49.5938,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 134.604,
    cy: 49.5938,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 141.628,
    cy: 49.5938,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 148.672,
    cy: 49.5943,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 155.693,
    cy: 49.5943,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 162.725,
    cy: 49.5943,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 169.755,
    cy: 49.5943,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 176.788,
    cy: 49.5943,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 183.82,
    cy: 49.5943,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 190.844,
    cy: 49.5943,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 197.874,
    cy: 49.5943,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 204.9,
    cy: 49.5943,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 211.938,
    cy: 49.5943,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 218.968,
    cy: 49.5943,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 226.004,
    cy: 49.5938,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 233.03,
    cy: 49.5938,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 240.059,
    cy: 49.5938,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 247.09,
    cy: 49.5943,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 254.116,
    cy: 49.5943,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 261.145,
    cy: 49.5943,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 268.181,
    cy: 49.5943,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 275.211,
    cy: 49.5943,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 282.24,
    cy: 49.5943,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 289.269,
    cy: 49.5943,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip8_1420_6457)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 22.1219,
    cy: 56.6246,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 29.1512,
    cy: 56.6246,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 36.1815,
    cy: 56.6246,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 43.2137,
    cy: 56.6246,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 50.2459,
    cy: 56.6246,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 57.2723,
    cy: 56.6246,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 64.3104,
    cy: 56.6246,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 71.3367,
    cy: 56.6246,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 78.3641,
    cy: 56.6246,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 85.3934,
    cy: 56.6246,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 92.4237,
    cy: 56.6246,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 99.4559,
    cy: 56.6246,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 106.482,
    cy: 56.6246,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 113.514,
    cy: 56.6246,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 120.545,
    cy: 56.6246,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 127.581,
    cy: 56.6246,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 134.604,
    cy: 56.6246,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 141.628,
    cy: 56.6246,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 148.672,
    cy: 56.6246,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 155.693,
    cy: 56.6246,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 162.725,
    cy: 56.6246,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 169.755,
    cy: 56.6246,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 176.788,
    cy: 56.6246,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 183.82,
    cy: 56.6246,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 190.844,
    cy: 56.6246,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 197.874,
    cy: 56.6246,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 204.9,
    cy: 56.6246,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 211.938,
    cy: 56.6246,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 218.968,
    cy: 56.6246,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 226.004,
    cy: 56.6246,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 233.03,
    cy: 56.6246,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 240.059,
    cy: 56.6246,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 247.09,
    cy: 56.6246,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 254.116,
    cy: 56.6246,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 261.145,
    cy: 56.6246,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 268.181,
    cy: 56.6246,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 275.211,
    cy: 56.6246,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 282.24,
    cy: 56.6246,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 289.269,
    cy: 56.6246,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip9_1420_6457)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 22.1219,
    cy: 63.6541,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 29.1512,
    cy: 63.6541,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 36.1815,
    cy: 63.6541,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 43.2137,
    cy: 63.6541,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 50.2459,
    cy: 63.6541,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 57.2723,
    cy: 63.6541,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 64.3104,
    cy: 63.6541,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 71.3367,
    cy: 63.6541,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 78.3641,
    cy: 63.6541,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 85.3934,
    cy: 63.6541,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 92.4237,
    cy: 63.6541,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 99.4559,
    cy: 63.6541,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 106.482,
    cy: 63.6541,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 113.514,
    cy: 63.6541,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 120.545,
    cy: 63.6541,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 127.581,
    cy: 63.6541,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 134.604,
    cy: 63.6541,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 141.628,
    cy: 63.6541,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 148.672,
    cy: 63.6541,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 155.693,
    cy: 63.6541,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 162.725,
    cy: 63.6541,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 169.755,
    cy: 63.6541,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 176.788,
    cy: 63.6541,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 183.82,
    cy: 63.6541,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 190.844,
    cy: 63.6541,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 197.874,
    cy: 63.6541,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 204.9,
    cy: 63.6541,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 211.938,
    cy: 63.6541,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 218.968,
    cy: 63.6541,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 226.004,
    cy: 63.6541,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 233.03,
    cy: 63.6541,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 240.059,
    cy: 63.6541,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 247.09,
    cy: 63.6541,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 254.116,
    cy: 63.6541,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 261.145,
    cy: 63.6541,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 268.181,
    cy: 63.6541,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 275.211,
    cy: 63.6541,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 282.24,
    cy: 63.6541,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 289.269,
    cy: 63.6541,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip10_1420_6457)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 22.1219,
    cy: 70.6854,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 29.1512,
    cy: 70.6851,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 36.1815,
    cy: 70.6851,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 43.2137,
    cy: 70.6851,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 50.2459,
    cy: 70.6851,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 57.2723,
    cy: 70.6851,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 64.3104,
    cy: 70.6851,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 71.3367,
    cy: 70.6851,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 78.3641,
    cy: 70.6851,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 85.3934,
    cy: 70.6851,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 92.4237,
    cy: 70.6851,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 99.4559,
    cy: 70.6851,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 106.482,
    cy: 70.6851,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 113.514,
    cy: 70.6851,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 120.545,
    cy: 70.6851,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 127.581,
    cy: 70.6851,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 134.604,
    cy: 70.6851,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 141.628,
    cy: 70.6851,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 148.672,
    cy: 70.6851,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 155.693,
    cy: 70.6851,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 162.725,
    cy: 70.6851,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 169.755,
    cy: 70.6851,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 176.788,
    cy: 70.6851,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 183.82,
    cy: 70.6851,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 190.844,
    cy: 70.6851,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 197.874,
    cy: 70.6851,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 204.9,
    cy: 70.6851,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 211.938,
    cy: 70.6851,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 218.968,
    cy: 70.6851,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 226.004,
    cy: 70.6851,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 233.03,
    cy: 70.6851,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 240.059,
    cy: 70.6851,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 247.09,
    cy: 70.6851,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 254.116,
    cy: 70.6851,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 261.145,
    cy: 70.6851,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 268.181,
    cy: 70.6851,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 275.211,
    cy: 70.6851,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 282.24,
    cy: 70.6851,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 289.269,
    cy: 70.6851,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip11_1420_6457)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 22.1219,
    cy: 77.7139,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 29.1512,
    cy: 77.7137,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 36.1815,
    cy: 77.7137,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 43.2137,
    cy: 77.7137,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 50.2459,
    cy: 77.7137,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 57.2723,
    cy: 77.7137,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 64.3104,
    cy: 77.7137,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 71.3367,
    cy: 77.7137,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 78.3641,
    cy: 77.7137,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 85.3934,
    cy: 77.7137,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 92.4237,
    cy: 77.7137,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 99.4559,
    cy: 77.7137,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 106.482,
    cy: 77.7137,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 113.514,
    cy: 77.7137,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 120.545,
    cy: 77.7137,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 127.581,
    cy: 77.7137,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 134.604,
    cy: 77.7137,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 141.628,
    cy: 77.7137,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 148.672,
    cy: 77.7137,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 155.693,
    cy: 77.7137,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 162.725,
    cy: 77.7137,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 169.755,
    cy: 77.7137,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 176.788,
    cy: 77.7137,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 183.82,
    cy: 77.7137,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 190.844,
    cy: 77.7137,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 197.874,
    cy: 77.7137,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 204.9,
    cy: 77.7137,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 211.938,
    cy: 77.7137,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 218.968,
    cy: 77.7137,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 226.004,
    cy: 77.7137,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 233.03,
    cy: 77.7137,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 240.059,
    cy: 77.7137,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 247.09,
    cy: 77.7137,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 254.116,
    cy: 77.7137,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 261.145,
    cy: 77.7137,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 268.181,
    cy: 77.7137,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 275.211,
    cy: 77.7137,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 282.24,
    cy: 77.7137,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 289.269,
    cy: 77.7137,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip12_1420_6457)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 22.1219,
    cy: 84.7445,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 29.1512,
    cy: 84.7447,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 36.1815,
    cy: 84.7447,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 43.2137,
    cy: 84.7447,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 50.2459,
    cy: 84.7447,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 57.2723,
    cy: 84.7447,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 64.3104,
    cy: 84.7447,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 71.3367,
    cy: 84.7447,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 78.3641,
    cy: 84.7447,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 85.3934,
    cy: 84.7447,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 92.4237,
    cy: 84.7447,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 99.4559,
    cy: 84.7447,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 106.482,
    cy: 84.7447,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 113.514,
    cy: 84.7447,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 120.545,
    cy: 84.7447,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 127.581,
    cy: 84.7447,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 134.604,
    cy: 84.7447,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 141.628,
    cy: 84.7447,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 148.672,
    cy: 84.7447,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 155.693,
    cy: 84.7447,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 162.725,
    cy: 84.7447,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 169.755,
    cy: 84.7447,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 176.788,
    cy: 84.7447,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 183.82,
    cy: 84.7447,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 190.844,
    cy: 84.7447,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 197.874,
    cy: 84.7447,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 204.9,
    cy: 84.7447,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 211.938,
    cy: 84.7447,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 218.968,
    cy: 84.7447,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 226.004,
    cy: 84.7447,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 233.03,
    cy: 84.7447,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 240.059,
    cy: 84.7447,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 247.09,
    cy: 84.7447,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 254.116,
    cy: 84.7447,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 261.145,
    cy: 84.7447,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 268.181,
    cy: 84.7447,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 275.211,
    cy: 84.7447,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 282.24,
    cy: 84.7447,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 289.269,
    cy: 84.7447,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip13_1420_6457)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 22.1219,
    cy: 91.775,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 29.1512,
    cy: 91.775,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 36.1815,
    cy: 91.775,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 43.2137,
    cy: 91.775,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 50.2459,
    cy: 91.775,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 57.2723,
    cy: 91.775,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 64.3104,
    cy: 91.775,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 71.3367,
    cy: 91.775,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 78.3641,
    cy: 91.775,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 85.3934,
    cy: 91.775,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 92.4237,
    cy: 91.775,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 99.4559,
    cy: 91.775,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 106.482,
    cy: 91.775,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 113.514,
    cy: 91.775,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 120.545,
    cy: 91.775,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 127.581,
    cy: 91.775,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 134.604,
    cy: 91.775,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 141.628,
    cy: 91.775,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 148.672,
    cy: 91.775,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 155.693,
    cy: 91.775,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 162.725,
    cy: 91.775,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 169.755,
    cy: 91.775,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 176.788,
    cy: 91.775,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 183.82,
    cy: 91.775,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 190.844,
    cy: 91.775,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 197.874,
    cy: 91.775,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 204.9,
    cy: 91.775,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 211.938,
    cy: 91.775,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 218.968,
    cy: 91.775,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 226.004,
    cy: 91.775,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 233.03,
    cy: 91.775,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 240.059,
    cy: 91.775,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 247.09,
    cy: 91.775,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 254.116,
    cy: 91.775,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 261.145,
    cy: 91.775,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 268.181,
    cy: 91.775,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 275.211,
    cy: 91.775,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 282.24,
    cy: 91.775,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 289.269,
    cy: 91.775,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip14_1420_6457)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 22.1219,
    cy: 98.8053,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 29.1512,
    cy: 98.8053,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 36.1815,
    cy: 98.8053,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 43.2137,
    cy: 98.8053,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 50.2459,
    cy: 98.8053,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 57.2723,
    cy: 98.8053,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 64.3104,
    cy: 98.8053,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 71.3367,
    cy: 98.8053,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 78.3641,
    cy: 98.8053,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 85.3934,
    cy: 98.8053,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 92.4237,
    cy: 98.8053,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 99.4559,
    cy: 98.8053,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 106.482,
    cy: 98.8053,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 113.514,
    cy: 98.8053,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 120.545,
    cy: 98.8053,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 127.581,
    cy: 98.8053,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 134.604,
    cy: 98.8053,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 141.628,
    cy: 98.8053,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 148.672,
    cy: 98.8053,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 155.693,
    cy: 98.8053,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 162.725,
    cy: 98.8053,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 169.755,
    cy: 98.8053,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 176.788,
    cy: 98.8053,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 183.82,
    cy: 98.8053,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 190.844,
    cy: 98.8053,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 197.874,
    cy: 98.8053,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 204.9,
    cy: 98.8053,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 211.938,
    cy: 98.8053,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 218.968,
    cy: 98.8053,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 226.004,
    cy: 98.8053,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 233.03,
    cy: 98.8053,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 240.059,
    cy: 98.8053,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 247.09,
    cy: 98.8053,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 254.116,
    cy: 98.8053,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 261.145,
    cy: 98.8053,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 268.181,
    cy: 98.8053,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 275.211,
    cy: 98.8053,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 282.24,
    cy: 98.8053,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 289.269,
    cy: 98.8053,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip15_1420_6457)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 22.1219,
    cy: 105.835,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 29.1512,
    cy: 105.835,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 36.1815,
    cy: 105.835,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 43.2137,
    cy: 105.835,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 50.2459,
    cy: 105.835,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 57.2723,
    cy: 105.835,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 64.3104,
    cy: 105.835,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 71.3367,
    cy: 105.835,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 78.3641,
    cy: 105.835,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 85.3934,
    cy: 105.835,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 92.4237,
    cy: 105.835,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 99.4559,
    cy: 105.835,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 106.482,
    cy: 105.835,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 113.514,
    cy: 105.835,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 120.545,
    cy: 105.835,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 127.581,
    cy: 105.835,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 134.604,
    cy: 105.835,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 141.628,
    cy: 105.835,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 148.672,
    cy: 105.835,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 155.693,
    cy: 105.835,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 162.725,
    cy: 105.835,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 169.755,
    cy: 105.835,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 176.788,
    cy: 105.835,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 183.82,
    cy: 105.835,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 190.844,
    cy: 105.835,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 197.874,
    cy: 105.835,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 204.9,
    cy: 105.835,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 211.938,
    cy: 105.835,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 218.968,
    cy: 105.835,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 226.004,
    cy: 105.835,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 233.03,
    cy: 105.835,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 240.059,
    cy: 105.835,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 247.09,
    cy: 105.835,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 254.116,
    cy: 105.835,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 261.145,
    cy: 105.835,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 268.181,
    cy: 105.835,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 275.211,
    cy: 105.835,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 282.24,
    cy: 105.835,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 289.269,
    cy: 105.835,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip16_1420_6457)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 22.1219,
    cy: 112.866,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 29.1512,
    cy: 112.866,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 36.1815,
    cy: 112.866,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 43.2137,
    cy: 112.866,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 50.2459,
    cy: 112.866,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 57.2723,
    cy: 112.866,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 64.3104,
    cy: 112.866,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 71.3367,
    cy: 112.866,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 78.3641,
    cy: 112.866,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 85.3934,
    cy: 112.866,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 92.4237,
    cy: 112.866,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 99.4559,
    cy: 112.866,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 106.482,
    cy: 112.866,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 113.514,
    cy: 112.866,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 120.545,
    cy: 112.866,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 127.581,
    cy: 112.866,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 134.604,
    cy: 112.866,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 141.628,
    cy: 112.866,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 148.672,
    cy: 112.866,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 155.693,
    cy: 112.866,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 162.725,
    cy: 112.866,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 169.755,
    cy: 112.866,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 176.788,
    cy: 112.866,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 183.82,
    cy: 112.866,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 190.844,
    cy: 112.866,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 197.874,
    cy: 112.866,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 204.9,
    cy: 112.866,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 211.938,
    cy: 112.866,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 218.968,
    cy: 112.866,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 226.004,
    cy: 112.866,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 233.03,
    cy: 112.866,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 240.059,
    cy: 112.866,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 247.09,
    cy: 112.866,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 254.116,
    cy: 112.866,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 261.145,
    cy: 112.866,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 268.181,
    cy: 112.866,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 275.211,
    cy: 112.866,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 282.24,
    cy: 112.866,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 289.269,
    cy: 112.866,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip17_1420_6457)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 22.1219,
    cy: 119.896,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 29.1512,
    cy: 119.896,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 36.1815,
    cy: 119.896,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 43.2137,
    cy: 119.896,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 50.2459,
    cy: 119.896,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 57.2723,
    cy: 119.896,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 64.3104,
    cy: 119.896,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 71.3367,
    cy: 119.896,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 78.3641,
    cy: 119.896,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 85.3934,
    cy: 119.896,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 92.4237,
    cy: 119.896,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 99.4559,
    cy: 119.896,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 106.482,
    cy: 119.896,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 113.514,
    cy: 119.896,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 120.545,
    cy: 119.896,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 127.581,
    cy: 119.896,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 134.604,
    cy: 119.896,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 141.628,
    cy: 119.896,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 148.672,
    cy: 119.896,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 155.693,
    cy: 119.896,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 162.725,
    cy: 119.896,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 169.755,
    cy: 119.896,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 176.788,
    cy: 119.896,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 183.82,
    cy: 119.896,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 190.844,
    cy: 119.896,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 197.874,
    cy: 119.896,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 204.9,
    cy: 119.896,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 211.938,
    cy: 119.896,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 218.968,
    cy: 119.896,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 226.004,
    cy: 119.896,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 233.03,
    cy: 119.896,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 240.059,
    cy: 119.896,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 247.09,
    cy: 119.896,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 254.116,
    cy: 119.896,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 261.145,
    cy: 119.896,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 268.181,
    cy: 119.896,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 275.211,
    cy: 119.896,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 282.24,
    cy: 119.896,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 289.269,
    cy: 119.896,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip18_1420_6457)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 22.1219,
    cy: 126.926,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 29.1512,
    cy: 126.926,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 36.1815,
    cy: 126.926,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 43.2137,
    cy: 126.926,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 50.2459,
    cy: 126.926,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 57.2723,
    cy: 126.926,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 64.3104,
    cy: 126.926,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 71.3367,
    cy: 126.926,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 78.3641,
    cy: 126.926,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 85.3934,
    cy: 126.926,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 92.4237,
    cy: 126.926,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 99.4559,
    cy: 126.926,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 106.482,
    cy: 126.926,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 113.514,
    cy: 126.926,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 120.545,
    cy: 126.926,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 127.581,
    cy: 126.926,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 134.604,
    cy: 126.926,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 141.628,
    cy: 126.926,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 148.672,
    cy: 126.926,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 155.693,
    cy: 126.926,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 162.725,
    cy: 126.926,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 169.755,
    cy: 126.926,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 176.788,
    cy: 126.926,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 183.82,
    cy: 126.926,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 190.844,
    cy: 126.926,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 197.874,
    cy: 126.926,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 204.9,
    cy: 126.926,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 211.938,
    cy: 126.926,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 218.968,
    cy: 126.926,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 226.004,
    cy: 126.926,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 233.03,
    cy: 126.926,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 240.059,
    cy: 126.926,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 247.09,
    cy: 126.926,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 254.116,
    cy: 126.926,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 261.145,
    cy: 126.926,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 268.181,
    cy: 126.926,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 275.211,
    cy: 126.926,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 282.24,
    cy: 126.926,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 289.269,
    cy: 126.926,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip19_1420_6457)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 22.1219,
    cy: 133.956,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 29.1512,
    cy: 133.956,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 36.1815,
    cy: 133.956,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 43.2137,
    cy: 133.956,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 50.2459,
    cy: 133.956,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 57.2723,
    cy: 133.956,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 64.3104,
    cy: 133.956,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 71.3367,
    cy: 133.956,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 78.3641,
    cy: 133.956,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 85.3934,
    cy: 133.956,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 92.4237,
    cy: 133.956,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 99.4559,
    cy: 133.956,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 106.482,
    cy: 133.956,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 113.514,
    cy: 133.956,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 120.545,
    cy: 133.956,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 127.581,
    cy: 133.956,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 134.604,
    cy: 133.956,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 141.628,
    cy: 133.956,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 148.672,
    cy: 133.956,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 155.693,
    cy: 133.956,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 162.725,
    cy: 133.956,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 169.755,
    cy: 133.956,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 176.788,
    cy: 133.956,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 183.82,
    cy: 133.956,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 190.844,
    cy: 133.956,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 197.874,
    cy: 133.956,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 204.9,
    cy: 133.956,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 211.938,
    cy: 133.956,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 218.968,
    cy: 133.956,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 226.004,
    cy: 133.956,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 233.03,
    cy: 133.956,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 240.059,
    cy: 133.956,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 247.09,
    cy: 133.956,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 254.116,
    cy: 133.956,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 261.145,
    cy: 133.956,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 268.181,
    cy: 133.956,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 275.211,
    cy: 133.956,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 282.24,
    cy: 133.956,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 289.269,
    cy: 133.956,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip20_1420_6457)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 22.1219,
    cy: 140.987,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 29.1512,
    cy: 140.987,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 36.1815,
    cy: 140.987,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 43.2137,
    cy: 140.987,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 50.2459,
    cy: 140.987,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 57.2723,
    cy: 140.987,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 64.3104,
    cy: 140.987,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 71.3367,
    cy: 140.987,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 78.3641,
    cy: 140.987,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 85.3934,
    cy: 140.987,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 92.4237,
    cy: 140.987,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 99.4559,
    cy: 140.987,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 106.482,
    cy: 140.987,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 113.514,
    cy: 140.987,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 120.545,
    cy: 140.987,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 127.581,
    cy: 140.987,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 134.604,
    cy: 140.987,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 141.628,
    cy: 140.987,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 148.672,
    cy: 140.987,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 155.693,
    cy: 140.987,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 162.725,
    cy: 140.987,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 169.755,
    cy: 140.987,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 176.788,
    cy: 140.987,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 183.82,
    cy: 140.987,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 190.844,
    cy: 140.987,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 197.874,
    cy: 140.987,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 204.9,
    cy: 140.987,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 211.938,
    cy: 140.987,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 218.968,
    cy: 140.987,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 226.004,
    cy: 140.987,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 233.03,
    cy: 140.987,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 240.059,
    cy: 140.987,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 247.09,
    cy: 140.987,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 254.116,
    cy: 140.987,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 261.145,
    cy: 140.987,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 268.181,
    cy: 140.987,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 275.211,
    cy: 140.987,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 282.24,
    cy: 140.987,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 289.269,
    cy: 140.987,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip21_1420_6457)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 22.1219,
    cy: 148.016,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 29.1512,
    cy: 148.016,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 36.1815,
    cy: 148.016,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 43.2137,
    cy: 148.016,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 50.2459,
    cy: 148.016,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 57.2723,
    cy: 148.016,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 64.3104,
    cy: 148.016,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 71.3367,
    cy: 148.016,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 78.3641,
    cy: 148.016,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 85.3934,
    cy: 148.016,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 92.4237,
    cy: 148.016,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 99.4559,
    cy: 148.016,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 106.482,
    cy: 148.016,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 113.514,
    cy: 148.016,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 120.545,
    cy: 148.016,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 127.581,
    cy: 148.016,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 134.604,
    cy: 148.016,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 141.628,
    cy: 148.016,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 148.672,
    cy: 148.016,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 155.693,
    cy: 148.016,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 162.725,
    cy: 148.016,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 169.755,
    cy: 148.016,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 176.788,
    cy: 148.016,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 183.82,
    cy: 148.016,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 190.844,
    cy: 148.016,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 197.874,
    cy: 148.016,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 204.9,
    cy: 148.016,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 211.938,
    cy: 148.016,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 218.968,
    cy: 148.016,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 226.004,
    cy: 148.016,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 233.03,
    cy: 148.016,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 240.059,
    cy: 148.016,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 247.09,
    cy: 148.016,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 254.116,
    cy: 148.016,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 261.145,
    cy: 148.016,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 268.181,
    cy: 148.016,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 275.211,
    cy: 148.016,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 282.24,
    cy: 148.016,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 289.269,
    cy: 148.016,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip22_1420_6457)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 22.1219,
    cy: 155.048,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 29.1512,
    cy: 155.048,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 36.1815,
    cy: 155.048,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 43.2137,
    cy: 155.048,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 50.2459,
    cy: 155.048,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 57.2723,
    cy: 155.048,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 64.3104,
    cy: 155.048,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 71.3367,
    cy: 155.048,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 78.3641,
    cy: 155.048,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 85.3934,
    cy: 155.048,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 92.4237,
    cy: 155.048,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 99.4559,
    cy: 155.048,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 106.482,
    cy: 155.048,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 113.514,
    cy: 155.048,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 120.545,
    cy: 155.048,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 127.581,
    cy: 155.048,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 134.604,
    cy: 155.048,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 141.628,
    cy: 155.048,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 148.672,
    cy: 155.048,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 155.693,
    cy: 155.048,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 162.725,
    cy: 155.048,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 169.755,
    cy: 155.048,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 176.788,
    cy: 155.048,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 183.82,
    cy: 155.048,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 190.844,
    cy: 155.048,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 197.874,
    cy: 155.048,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 204.9,
    cy: 155.048,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 211.938,
    cy: 155.048,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 218.968,
    cy: 155.048,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 226.004,
    cy: 155.048,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 233.03,
    cy: 155.048,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 240.059,
    cy: 155.048,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 247.09,
    cy: 155.048,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 254.116,
    cy: 155.048,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 261.145,
    cy: 155.048,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 268.181,
    cy: 155.048,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 275.211,
    cy: 155.048,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 282.24,
    cy: 155.048,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 289.269,
    cy: 155.048,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip23_1420_6457)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 22.1219,
    cy: 162.077,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 29.1512,
    cy: 162.077,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 36.1815,
    cy: 162.077,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 43.2137,
    cy: 162.077,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 50.2459,
    cy: 162.077,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 57.2723,
    cy: 162.077,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 64.3104,
    cy: 162.077,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 71.3367,
    cy: 162.077,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 78.3641,
    cy: 162.077,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 85.3934,
    cy: 162.077,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 92.4237,
    cy: 162.077,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 99.4559,
    cy: 162.077,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 106.482,
    cy: 162.077,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 113.514,
    cy: 162.077,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 120.545,
    cy: 162.077,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 127.581,
    cy: 162.077,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 134.604,
    cy: 162.077,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 141.628,
    cy: 162.077,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 148.672,
    cy: 162.077,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 155.693,
    cy: 162.077,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 162.725,
    cy: 162.077,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 169.755,
    cy: 162.077,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 176.788,
    cy: 162.077,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 183.82,
    cy: 162.077,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 190.844,
    cy: 162.077,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 197.874,
    cy: 162.077,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 204.9,
    cy: 162.077,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 211.938,
    cy: 162.077,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 218.968,
    cy: 162.077,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 226.004,
    cy: 162.077,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 233.03,
    cy: 162.077,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 240.059,
    cy: 162.077,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 247.09,
    cy: 162.077,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 254.116,
    cy: 162.077,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 261.145,
    cy: 162.077,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 268.181,
    cy: 162.077,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 275.211,
    cy: 162.077,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 282.24,
    cy: 162.077,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 289.269,
    cy: 162.077,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip24_1420_6457)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 22.1219,
    cy: 169.107,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 29.1512,
    cy: 169.107,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 36.1815,
    cy: 169.107,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 43.2137,
    cy: 169.107,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 50.2459,
    cy: 169.107,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 57.2723,
    cy: 169.107,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 64.3104,
    cy: 169.107,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 71.3367,
    cy: 169.107,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 78.3641,
    cy: 169.107,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 85.3934,
    cy: 169.107,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 92.4237,
    cy: 169.107,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 99.4559,
    cy: 169.107,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 106.482,
    cy: 169.107,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 113.514,
    cy: 169.107,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 120.545,
    cy: 169.107,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 127.581,
    cy: 169.107,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 134.604,
    cy: 169.107,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 141.628,
    cy: 169.107,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 148.672,
    cy: 169.107,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 155.693,
    cy: 169.107,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 162.725,
    cy: 169.107,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 169.755,
    cy: 169.107,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 176.788,
    cy: 169.107,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 183.82,
    cy: 169.107,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 190.844,
    cy: 169.107,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 197.874,
    cy: 169.107,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 204.9,
    cy: 169.107,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 211.938,
    cy: 169.107,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 218.968,
    cy: 169.107,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 226.004,
    cy: 169.107,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 233.03,
    cy: 169.107,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 240.059,
    cy: 169.107,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 247.09,
    cy: 169.107,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 254.116,
    cy: 169.107,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 261.145,
    cy: 169.107,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 268.181,
    cy: 169.107,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 275.211,
    cy: 169.107,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 282.24,
    cy: 169.107,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 289.269,
    cy: 169.107,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip25_1420_6457)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 22.1219,
    cy: 176.138,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 29.1512,
    cy: 176.138,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 36.1815,
    cy: 176.138,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 43.2137,
    cy: 176.138,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 50.2459,
    cy: 176.138,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 57.2723,
    cy: 176.138,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 64.3104,
    cy: 176.138,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 71.3367,
    cy: 176.138,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 78.3641,
    cy: 176.138,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 85.3934,
    cy: 176.138,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 92.4237,
    cy: 176.138,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 99.4559,
    cy: 176.138,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 106.482,
    cy: 176.138,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 113.514,
    cy: 176.138,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 120.545,
    cy: 176.138,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 127.581,
    cy: 176.138,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 134.604,
    cy: 176.138,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 141.628,
    cy: 176.138,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 148.672,
    cy: 176.138,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 155.693,
    cy: 176.138,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 162.725,
    cy: 176.138,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 169.755,
    cy: 176.138,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 176.788,
    cy: 176.138,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 183.82,
    cy: 176.138,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 190.844,
    cy: 176.138,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 197.874,
    cy: 176.138,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 204.9,
    cy: 176.138,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 211.938,
    cy: 176.138,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 218.968,
    cy: 176.138,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 226.004,
    cy: 176.138,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 233.03,
    cy: 176.138,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 240.059,
    cy: 176.138,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 247.09,
    cy: 176.138,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 254.116,
    cy: 176.138,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 261.145,
    cy: 176.138,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 268.181,
    cy: 176.138,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 275.211,
    cy: 176.138,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 282.24,
    cy: 176.138,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 289.269,
    cy: 176.138,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip26_1420_6457)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 22.1219,
    cy: 183.168,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 29.1512,
    cy: 183.168,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 36.1815,
    cy: 183.168,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 43.2137,
    cy: 183.168,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 50.2459,
    cy: 183.168,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 57.2723,
    cy: 183.168,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 64.3104,
    cy: 183.168,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 71.3367,
    cy: 183.168,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 78.3641,
    cy: 183.168,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 85.3934,
    cy: 183.168,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 92.4237,
    cy: 183.168,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 99.4559,
    cy: 183.168,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 106.482,
    cy: 183.168,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 113.514,
    cy: 183.168,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 120.545,
    cy: 183.168,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 127.581,
    cy: 183.168,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 134.604,
    cy: 183.168,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 141.628,
    cy: 183.168,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 148.672,
    cy: 183.168,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 155.693,
    cy: 183.168,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 162.725,
    cy: 183.168,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 169.755,
    cy: 183.168,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 176.788,
    cy: 183.168,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 183.82,
    cy: 183.168,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 190.844,
    cy: 183.168,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 197.874,
    cy: 183.168,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 204.9,
    cy: 183.168,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 211.938,
    cy: 183.168,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 218.968,
    cy: 183.168,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 226.004,
    cy: 183.168,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 233.03,
    cy: 183.168,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 240.059,
    cy: 183.168,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 247.09,
    cy: 183.168,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 254.116,
    cy: 183.168,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 261.145,
    cy: 183.168,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 268.181,
    cy: 183.168,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 275.211,
    cy: 183.168,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 282.24,
    cy: 183.168,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 289.269,
    cy: 183.168,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip27_1420_6457)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 22.1219,
    cy: 190.198,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 29.1512,
    cy: 190.198,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 36.1815,
    cy: 190.199,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 43.2137,
    cy: 190.199,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 50.2459,
    cy: 190.199,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 57.2723,
    cy: 190.199,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 64.3104,
    cy: 190.198,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 71.3367,
    cy: 190.198,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 78.3641,
    cy: 190.198,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 85.3934,
    cy: 190.198,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 92.4237,
    cy: 190.198,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 99.4559,
    cy: 190.198,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 106.482,
    cy: 190.198,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 113.514,
    cy: 190.198,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 120.545,
    cy: 190.198,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 127.581,
    cy: 190.199,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 134.604,
    cy: 190.199,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 141.628,
    cy: 190.199,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 148.672,
    cy: 190.198,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 155.693,
    cy: 190.198,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 162.725,
    cy: 190.198,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 169.755,
    cy: 190.198,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 176.788,
    cy: 190.198,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 183.82,
    cy: 190.198,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 190.844,
    cy: 190.198,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 197.874,
    cy: 190.198,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 204.9,
    cy: 190.198,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 211.938,
    cy: 190.198,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 218.968,
    cy: 190.198,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 226.004,
    cy: 190.199,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 233.03,
    cy: 190.199,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 240.059,
    cy: 190.199,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 247.09,
    cy: 190.198,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 254.116,
    cy: 190.198,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 261.145,
    cy: 190.198,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 268.181,
    cy: 190.198,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 275.211,
    cy: 190.198,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 282.24,
    cy: 190.198,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 289.269,
    cy: 190.198,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip28_1420_6457)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 22.1219,
    cy: 197.229,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 29.1512,
    cy: 197.229,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 36.1815,
    cy: 197.229,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 43.2137,
    cy: 197.229,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 50.2459,
    cy: 197.229,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 57.2723,
    cy: 197.229,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 64.3104,
    cy: 197.229,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 71.3367,
    cy: 197.229,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 78.3641,
    cy: 197.229,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 85.3934,
    cy: 197.229,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 92.4237,
    cy: 197.229,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 99.4559,
    cy: 197.229,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 106.482,
    cy: 197.229,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 113.514,
    cy: 197.229,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 120.545,
    cy: 197.229,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 127.581,
    cy: 197.229,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 134.604,
    cy: 197.229,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 141.628,
    cy: 197.229,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 148.672,
    cy: 197.229,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 155.693,
    cy: 197.229,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 162.725,
    cy: 197.229,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 169.755,
    cy: 197.229,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 176.788,
    cy: 197.229,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 183.82,
    cy: 197.229,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 190.844,
    cy: 197.229,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 197.874,
    cy: 197.229,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 204.9,
    cy: 197.229,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 211.938,
    cy: 197.229,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 218.968,
    cy: 197.229,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 226.004,
    cy: 197.229,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 233.03,
    cy: 197.229,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 240.059,
    cy: 197.229,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 247.09,
    cy: 197.229,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 254.116,
    cy: 197.229,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 261.145,
    cy: 197.229,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 268.181,
    cy: 197.229,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 275.211,
    cy: 197.229,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 282.24,
    cy: 197.229,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 289.269,
    cy: 197.229,
    rx: 1.1717,
    ry: 1.1717,
    fill: "#3052C8",
    fillOpacity: 0.1
  }))), /*#__PURE__*/React.createElement("rect", {
    x: 20.4641,
    y: 32.7212,
    width: 274.365,
    height: 51.3648,
    rx: 5.68239,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 20.4641,
    y: 32.7212,
    width: 274.365,
    height: 51.3648,
    rx: 5.68239,
    stroke: "#CCCCCC",
    strokeWidth: 0.635223
  }), /*#__PURE__*/React.createElement("rect", {
    x: 32.4951,
    y: 44.7522,
    width: 85.3028,
    height: 27.3028,
    rx: 2.44032,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 32.4951,
    y: 44.7522,
    width: 85.3028,
    height: 27.3028,
    rx: 2.44032,
    stroke: "#8EE6D7",
    strokeWidth: 0.697233
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.7326 62.4036H40.5446V54.9516H37.8206V53.9076H44.4566V54.9516H41.7326V62.4036ZM50.1402 59.5476C50.1402 59.9876 50.0602 60.3916 49.9002 60.7596C49.7482 61.1276 49.5322 61.4476 49.2522 61.7196C48.9802 61.9836 48.6562 62.1916 48.2802 62.3436C47.9042 62.4876 47.5002 62.5596 47.0682 62.5596C46.6362 62.5596 46.2322 62.4876 45.8562 62.3436C45.4802 62.1916 45.1562 61.9836 44.8842 61.7196C44.6122 61.4476 44.3962 61.1276 44.2362 60.7596C44.0842 60.3916 44.0082 59.9876 44.0082 59.5476C44.0082 59.1076 44.0842 58.7076 44.2362 58.3476C44.3962 57.9796 44.6122 57.6636 44.8842 57.3996C45.1562 57.1356 45.4802 56.9316 45.8562 56.7876C46.2322 56.6356 46.6362 56.5596 47.0682 56.5596C47.5002 56.5596 47.9042 56.6356 48.2802 56.7876C48.6562 56.9316 48.9802 57.1356 49.2522 57.3996C49.5322 57.6636 49.7482 57.9796 49.9002 58.3476C50.0602 58.7076 50.1402 59.1076 50.1402 59.5476ZM48.9642 59.5476C48.9642 59.2756 48.9202 59.0156 48.8322 58.7676C48.7522 58.5196 48.6322 58.3036 48.4722 58.1196C48.3122 57.9276 48.1122 57.7756 47.8722 57.6636C47.6402 57.5516 47.3722 57.4956 47.0682 57.4956C46.7642 57.4956 46.4922 57.5516 46.2522 57.6636C46.0202 57.7756 45.8242 57.9276 45.6642 58.1196C45.5042 58.3036 45.3802 58.5196 45.2922 58.7676C45.2122 59.0156 45.1722 59.2756 45.1722 59.5476C45.1722 59.8196 45.2122 60.0796 45.2922 60.3276C45.3802 60.5756 45.5042 60.7956 45.6642 60.9876C45.8242 61.1796 46.0202 61.3316 46.2522 61.4436C46.4922 61.5556 46.7642 61.6116 47.0682 61.6116C47.3722 61.6116 47.6402 61.5556 47.8722 61.4436C48.1122 61.3316 48.3122 61.1796 48.4722 60.9876C48.6322 60.7956 48.7522 60.5756 48.8322 60.3276C48.9202 60.0796 48.9642 59.8196 48.9642 59.5476ZM54.4884 57.6396H52.9764V60.6036C52.9764 60.9476 53.0404 61.1956 53.1684 61.3476C53.2964 61.4916 53.5004 61.5636 53.7804 61.5636C53.8844 61.5636 53.9964 61.5516 54.1164 61.5276C54.2364 61.5036 54.3444 61.4676 54.4404 61.4196L54.4764 62.3436C54.3404 62.3916 54.1884 62.4276 54.0204 62.4516C53.8604 62.4836 53.6924 62.4996 53.5164 62.4996C52.9804 62.4996 52.5684 62.3516 52.2804 62.0556C52.0004 61.7596 51.8604 61.3156 51.8604 60.7236V57.6396H50.7684V56.7156H51.8604V55.0836H52.9764V56.7156H54.4884V57.6396ZM59.1936 58.7196C59.1936 58.2956 59.0656 57.9836 58.8096 57.7836C58.5536 57.5756 58.2136 57.4716 57.7896 57.4716C57.4696 57.4716 57.1656 57.5356 56.8776 57.6636C56.5976 57.7836 56.3616 57.9396 56.1696 58.1316L55.5696 57.4116C55.8496 57.1476 56.1896 56.9396 56.5896 56.7876C56.9976 56.6356 57.4336 56.5596 57.8976 56.5596C58.3056 56.5596 58.6576 56.6196 58.9536 56.7396C59.2576 56.8516 59.5056 57.0076 59.6976 57.2076C59.8896 57.4076 60.0336 57.6436 60.1296 57.9156C60.2256 58.1876 60.2736 58.4796 60.2736 58.7916V61.2756C60.2736 61.4676 60.2776 61.6716 60.2856 61.8876C60.3016 62.0956 60.3256 62.2676 60.3576 62.4036H59.3376C59.2736 62.1316 59.2416 61.8596 59.2416 61.5876H59.2056C58.9976 61.8916 58.7336 62.1276 58.4136 62.2956C58.1016 62.4636 57.7296 62.5476 57.2976 62.5476C57.0736 62.5476 56.8376 62.5156 56.5896 62.4516C56.3496 62.3956 56.1296 62.2996 55.9296 62.1636C55.7296 62.0276 55.5616 61.8476 55.4256 61.6236C55.2976 61.3996 55.2336 61.1236 55.2336 60.7956C55.2336 60.3636 55.3496 60.0236 55.5816 59.7756C55.8136 59.5196 56.1176 59.3276 56.4936 59.1996C56.8696 59.0636 57.2936 58.9756 57.7656 58.9356C58.2376 58.8956 58.7136 58.8756 59.1936 58.8756V58.7196ZM58.9176 59.6916C58.6376 59.6916 58.3456 59.7036 58.0416 59.7276C57.7456 59.7516 57.4736 59.7996 57.2256 59.8716C56.9856 59.9436 56.7856 60.0516 56.6256 60.1956C56.4656 60.3396 56.3856 60.5316 56.3856 60.7716C56.3856 60.9396 56.4176 61.0796 56.4816 61.1916C56.5536 61.3036 56.6456 61.3956 56.7576 61.4676C56.8696 61.5396 56.9936 61.5916 57.1296 61.6236C57.2656 61.6476 57.4056 61.6596 57.5496 61.6596C58.0776 61.6596 58.4816 61.5036 58.7616 61.1916C59.0496 60.8716 59.1936 60.4716 59.1936 59.9916V59.6916H58.9176ZM63.3095 62.4036H62.1815V53.3316H63.3095V62.4036ZM69.3787 57.6516C69.5227 57.3476 69.7507 57.0916 70.0627 56.8836C70.3827 56.6676 70.7587 56.5596 71.1907 56.5596C71.5747 56.5596 71.9187 56.6476 72.2227 56.8236C72.5347 56.9996 72.7787 57.2916 72.9547 57.6996C73.1467 57.3316 73.4147 57.0516 73.7587 56.8596C74.1027 56.6596 74.4787 56.5596 74.8867 56.5596C75.2547 56.5596 75.5707 56.6236 75.8347 56.7516C76.0987 56.8716 76.3187 57.0356 76.4947 57.2436C76.6707 57.4516 76.7987 57.6956 76.8787 57.9756C76.9667 58.2556 77.0107 58.5556 77.0107 58.8756V62.4036H75.8827V59.2476C75.8827 59.0156 75.8627 58.7956 75.8227 58.5876C75.7827 58.3796 75.7147 58.1956 75.6187 58.0356C75.5227 57.8756 75.3947 57.7476 75.2347 57.6516C75.0747 57.5556 74.8707 57.5076 74.6227 57.5076C74.3667 57.5076 74.1467 57.5636 73.9627 57.6756C73.7787 57.7796 73.6267 57.9196 73.5067 58.0956C73.3947 58.2636 73.3107 58.4556 73.2547 58.6716C73.2067 58.8876 73.1827 59.1076 73.1827 59.3316V62.4036H72.0547V59.0196C72.0547 58.7956 72.0347 58.5916 71.9947 58.4076C71.9547 58.2236 71.8867 58.0676 71.7907 57.9396C71.6947 57.8036 71.5707 57.6996 71.4187 57.6276C71.2667 57.5476 71.0787 57.5076 70.8547 57.5076C70.4387 57.5076 70.0907 57.6796 69.8107 58.0236C69.5387 58.3596 69.4027 58.8116 69.4027 59.3796V62.4036H68.2747V57.9396C68.2747 57.7876 68.2707 57.5916 68.2627 57.3516C68.2547 57.1116 68.2427 56.8996 68.2267 56.7156H69.2947C69.3107 56.8596 69.3227 57.0236 69.3307 57.2076C69.3387 57.3836 69.3427 57.5316 69.3427 57.6516H69.3787ZM80.0554 62.4036H78.9274V56.7156H80.0554V62.4036ZM80.2474 54.6636C80.2474 54.8716 80.1714 55.0436 80.0194 55.1796C79.8754 55.3156 79.6994 55.3836 79.4914 55.3836C79.2834 55.3836 79.1074 55.3156 78.9634 55.1796C78.8194 55.0356 78.7474 54.8636 78.7474 54.6636C78.7474 54.4556 78.8194 54.2836 78.9634 54.1476C79.1074 54.0036 79.2834 53.9316 79.4914 53.9316C79.6994 53.9316 79.8754 54.0036 80.0194 54.1476C80.1714 54.2836 80.2474 54.4556 80.2474 54.6636ZM83.1728 62.4036H82.0448V53.3316H83.1728V62.4036ZM89.302 59.0556C89.294 58.8316 89.254 58.6236 89.182 58.4316C89.118 58.2316 89.018 58.0596 88.882 57.9156C88.754 57.7716 88.59 57.6596 88.39 57.5796C88.198 57.4916 87.97 57.4476 87.706 57.4476C87.466 57.4476 87.238 57.4916 87.022 57.5796C86.814 57.6596 86.63 57.7716 86.47 57.9156C86.318 58.0596 86.19 58.2316 86.086 58.4316C85.99 58.6236 85.934 58.8316 85.918 59.0556H89.302ZM90.442 59.5116C90.442 59.5756 90.442 59.6396 90.442 59.7036C90.442 59.7676 90.438 59.8316 90.43 59.8956H85.918C85.926 60.1356 85.978 60.3636 86.074 60.5796C86.178 60.7876 86.314 60.9716 86.482 61.1316C86.65 61.2836 86.842 61.4036 87.058 61.4916C87.282 61.5796 87.518 61.6236 87.766 61.6236C88.15 61.6236 88.482 61.5396 88.762 61.3716C89.042 61.2036 89.262 60.9996 89.422 60.7596L90.214 61.3956C89.91 61.7956 89.55 62.0916 89.134 62.2836C88.726 62.4676 88.27 62.5596 87.766 62.5596C87.334 62.5596 86.934 62.4876 86.566 62.3436C86.198 62.1996 85.882 61.9996 85.618 61.7436C85.354 61.4796 85.146 61.1636 84.994 60.7956C84.842 60.4276 84.766 60.0196 84.766 59.5716C84.766 59.1316 84.838 58.7276 84.982 58.3596C85.134 57.9836 85.342 57.6636 85.606 57.3996C85.87 57.1356 86.182 56.9316 86.542 56.7876C86.902 56.6356 87.29 56.5596 87.706 56.5596C88.122 56.5596 88.498 56.6276 88.834 56.7636C89.178 56.8996 89.466 57.0956 89.698 57.3516C89.938 57.6076 90.122 57.9196 90.25 58.2876C90.378 58.6476 90.442 59.0556 90.442 59.5116ZM95.0889 58.1556C94.9609 57.9476 94.7809 57.7796 94.5489 57.6516C94.3169 57.5156 94.0569 57.4476 93.7689 57.4476C93.6409 57.4476 93.5129 57.4636 93.3849 57.4956C93.2569 57.5196 93.1409 57.5636 93.0369 57.6276C92.9409 57.6836 92.8609 57.7596 92.7969 57.8556C92.7409 57.9436 92.7129 58.0556 92.7129 58.1916C92.7129 58.4316 92.8209 58.6116 93.0369 58.7316C93.2529 58.8436 93.5769 58.9476 94.0089 59.0436C94.2809 59.1076 94.5329 59.1836 94.7649 59.2716C94.9969 59.3596 95.1969 59.4716 95.3649 59.6076C95.5409 59.7356 95.6769 59.8916 95.7729 60.0756C95.8689 60.2596 95.9169 60.4756 95.9169 60.7236C95.9169 61.0596 95.8529 61.3436 95.7249 61.5756C95.5969 61.8076 95.4249 61.9996 95.2089 62.1516C95.0009 62.2956 94.7609 62.3996 94.4889 62.4636C94.2169 62.5276 93.9369 62.5596 93.6489 62.5596C93.2169 62.5596 92.7929 62.4756 92.3769 62.3076C91.9689 62.1396 91.6289 61.8836 91.3569 61.5396L92.1609 60.8556C92.3129 61.0796 92.5209 61.2676 92.7849 61.4196C93.0569 61.5716 93.3529 61.6476 93.6729 61.6476C93.8169 61.6476 93.9529 61.6356 94.0809 61.6116C94.2169 61.5796 94.3369 61.5316 94.4409 61.4676C94.5529 61.4036 94.6409 61.3196 94.7049 61.2156C94.7689 61.1116 94.8009 60.9796 94.8009 60.8196C94.8009 60.5556 94.6729 60.3596 94.4169 60.2316C94.1689 60.1036 93.8009 59.9836 93.3129 59.8716C93.1209 59.8236 92.9249 59.7676 92.7249 59.7036C92.5329 59.6316 92.3569 59.5356 92.1969 59.4156C92.0369 59.2956 91.9049 59.1476 91.8009 58.9716C91.7049 58.7876 91.6569 58.5636 91.6569 58.2996C91.6569 57.9956 91.7169 57.7356 91.8369 57.5196C91.9649 57.2956 92.1289 57.1156 92.3289 56.9796C92.5289 56.8356 92.7569 56.7316 93.0129 56.6676C93.2689 56.5956 93.5329 56.5596 93.8049 56.5596C94.2129 56.5596 94.6049 56.6396 94.9809 56.7996C95.3649 56.9596 95.6609 57.1916 95.8689 57.4956L95.0889 58.1556Z",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.134 57.009L107.781 60.7276L104.626 57.009",
    stroke: "#73767D",
    strokeWidth: 0.697231,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 122.495,
    y: 44.7522,
    width: 106.303,
    height: 27.3028,
    rx: 2.44032,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 122.495,
    y: 44.7522,
    width: 106.303,
    height: 27.3028,
    rx: 2.44032,
    stroke: "#CCCCCC",
    strokeWidth: 0.697233
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.945 62.4036H128.757V53.9076H129.945V62.4036ZM135.026 58.1556C134.898 57.9476 134.718 57.7796 134.486 57.6516C134.254 57.5156 133.994 57.4476 133.706 57.4476C133.578 57.4476 133.45 57.4636 133.322 57.4956C133.194 57.5196 133.078 57.5636 132.974 57.6276C132.878 57.6836 132.798 57.7596 132.734 57.8556C132.678 57.9436 132.65 58.0556 132.65 58.1916C132.65 58.4316 132.758 58.6116 132.974 58.7316C133.19 58.8436 133.514 58.9476 133.946 59.0436C134.218 59.1076 134.47 59.1836 134.702 59.2716C134.934 59.3596 135.134 59.4716 135.302 59.6076C135.478 59.7356 135.614 59.8916 135.71 60.0756C135.806 60.2596 135.854 60.4756 135.854 60.7236C135.854 61.0596 135.79 61.3436 135.662 61.5756C135.534 61.8076 135.362 61.9996 135.146 62.1516C134.938 62.2956 134.698 62.3996 134.426 62.4636C134.154 62.5276 133.874 62.5596 133.586 62.5596C133.154 62.5596 132.73 62.4756 132.314 62.3076C131.906 62.1396 131.566 61.8836 131.294 61.5396L132.098 60.8556C132.25 61.0796 132.458 61.2676 132.722 61.4196C132.994 61.5716 133.29 61.6476 133.61 61.6476C133.754 61.6476 133.89 61.6356 134.018 61.6116C134.154 61.5796 134.274 61.5316 134.378 61.4676C134.49 61.4036 134.578 61.3196 134.642 61.2156C134.706 61.1116 134.738 60.9796 134.738 60.8196C134.738 60.5556 134.61 60.3596 134.354 60.2316C134.106 60.1036 133.738 59.9836 133.25 59.8716C133.058 59.8236 132.862 59.7676 132.662 59.7036C132.47 59.6316 132.294 59.5356 132.134 59.4156C131.974 59.2956 131.842 59.1476 131.738 58.9716C131.642 58.7876 131.594 58.5636 131.594 58.2996C131.594 57.9956 131.654 57.7356 131.774 57.5196C131.902 57.2956 132.066 57.1156 132.266 56.9796C132.466 56.8356 132.694 56.7316 132.95 56.6676C133.206 56.5956 133.47 56.5596 133.742 56.5596C134.15 56.5596 134.542 56.6396 134.918 56.7996C135.302 56.9596 135.598 57.1916 135.806 57.4956L135.026 58.1556ZM140.73 63.3756C140.978 63.6556 141.286 63.8796 141.654 64.0476C142.03 64.2156 142.414 64.2996 142.806 64.2996C143.182 64.2996 143.498 64.2436 143.754 64.1316C144.01 64.0276 144.214 63.8796 144.366 63.6876C144.526 63.5036 144.638 63.2836 144.702 63.0276C144.774 62.7716 144.81 62.4956 144.81 62.1996V61.4676H144.786C144.578 61.7876 144.294 62.0316 143.934 62.1996C143.574 62.3676 143.19 62.4516 142.782 62.4516C142.35 62.4516 141.954 62.3756 141.594 62.2236C141.242 62.0716 140.942 61.8636 140.694 61.5996C140.446 61.3356 140.254 61.0276 140.118 60.6756C139.982 60.3156 139.914 59.9316 139.914 59.5236C139.914 59.1156 139.982 58.7316 140.118 58.3716C140.254 58.0116 140.446 57.6996 140.694 57.4356C140.942 57.1636 141.242 56.9516 141.594 56.7996C141.946 56.6396 142.338 56.5596 142.77 56.5596C143.178 56.5596 143.566 56.6476 143.934 56.8236C144.31 56.9996 144.606 57.2676 144.822 57.6276H144.846V56.7156H145.938V62.1156C145.938 62.5316 145.886 62.9276 145.782 63.3036C145.678 63.6876 145.502 64.0236 145.254 64.3116C145.006 64.6076 144.682 64.8436 144.282 65.0196C143.882 65.1956 143.386 65.2836 142.794 65.2836C142.298 65.2836 141.798 65.1916 141.294 65.0076C140.798 64.8316 140.37 64.5796 140.01 64.2516L140.73 63.3756ZM141.078 59.4996C141.078 59.7636 141.118 60.0156 141.198 60.2556C141.286 60.4956 141.41 60.7076 141.57 60.8916C141.738 61.0756 141.938 61.2236 142.17 61.3356C142.402 61.4476 142.666 61.5036 142.962 61.5036C143.25 61.5036 143.514 61.4516 143.754 61.3476C143.994 61.2436 144.198 61.1036 144.366 60.9276C144.534 60.7436 144.662 60.5316 144.75 60.2916C144.846 60.0436 144.894 59.7796 144.894 59.4996C144.894 59.2276 144.846 58.9716 144.75 58.7316C144.662 58.4916 144.53 58.2796 144.354 58.0956C144.186 57.9116 143.982 57.7676 143.742 57.6636C143.51 57.5516 143.25 57.4956 142.962 57.4956C142.666 57.4956 142.402 57.5516 142.17 57.6636C141.938 57.7676 141.738 57.9116 141.57 58.0956C141.41 58.2716 141.286 58.4836 141.198 58.7316C141.118 58.9716 141.078 59.2276 141.078 59.4996ZM147.868 57.9396C147.868 57.7876 147.864 57.5916 147.856 57.3516C147.848 57.1116 147.836 56.8996 147.82 56.7156H148.888C148.904 56.8596 148.916 57.0276 148.924 57.2196C148.932 57.4036 148.936 57.5556 148.936 57.6756H148.972C149.132 57.3396 149.364 57.0716 149.668 56.8716C149.98 56.6636 150.328 56.5596 150.712 56.5596C150.888 56.5596 151.036 56.5756 151.156 56.6076L151.108 57.6516C150.948 57.6116 150.776 57.5916 150.592 57.5916C150.32 57.5916 150.084 57.6436 149.884 57.7476C149.684 57.8436 149.516 57.9756 149.38 58.1436C149.252 58.3116 149.156 58.5076 149.092 58.7316C149.028 58.9476 148.996 59.1756 148.996 59.4156V62.4036H147.868V57.9396ZM156.169 59.0556C156.161 58.8316 156.121 58.6236 156.049 58.4316C155.985 58.2316 155.885 58.0596 155.749 57.9156C155.621 57.7716 155.457 57.6596 155.257 57.5796C155.065 57.4916 154.837 57.4476 154.573 57.4476C154.333 57.4476 154.105 57.4916 153.889 57.5796C153.681 57.6596 153.497 57.7716 153.337 57.9156C153.185 58.0596 153.057 58.2316 152.953 58.4316C152.857 58.6236 152.801 58.8316 152.785 59.0556H156.169ZM157.309 59.5116C157.309 59.5756 157.309 59.6396 157.309 59.7036C157.309 59.7676 157.305 59.8316 157.297 59.8956H152.785C152.793 60.1356 152.845 60.3636 152.941 60.5796C153.045 60.7876 153.181 60.9716 153.349 61.1316C153.517 61.2836 153.709 61.4036 153.925 61.4916C154.149 61.5796 154.385 61.6236 154.633 61.6236C155.017 61.6236 155.349 61.5396 155.629 61.3716C155.909 61.2036 156.129 60.9996 156.289 60.7596L157.081 61.3956C156.777 61.7956 156.417 62.0916 156.001 62.2836C155.593 62.4676 155.137 62.5596 154.633 62.5596C154.201 62.5596 153.801 62.4876 153.433 62.3436C153.065 62.1996 152.749 61.9996 152.485 61.7436C152.221 61.4796 152.013 61.1636 151.861 60.7956C151.709 60.4276 151.633 60.0196 151.633 59.5716C151.633 59.1316 151.705 58.7276 151.849 58.3596C152.001 57.9836 152.209 57.6636 152.473 57.3996C152.737 57.1356 153.049 56.9316 153.409 56.7876C153.769 56.6356 154.157 56.5596 154.573 56.5596C154.989 56.5596 155.365 56.6276 155.701 56.7636C156.045 56.8996 156.333 57.0956 156.565 57.3516C156.805 57.6076 156.989 57.9196 157.117 58.2876C157.245 58.6476 157.309 59.0556 157.309 59.5116ZM162.354 58.7196C162.354 58.2956 162.226 57.9836 161.97 57.7836C161.714 57.5756 161.374 57.4716 160.95 57.4716C160.63 57.4716 160.326 57.5356 160.038 57.6636C159.758 57.7836 159.522 57.9396 159.33 58.1316L158.73 57.4116C159.01 57.1476 159.35 56.9396 159.75 56.7876C160.158 56.6356 160.594 56.5596 161.058 56.5596C161.466 56.5596 161.818 56.6196 162.114 56.7396C162.418 56.8516 162.666 57.0076 162.858 57.2076C163.05 57.4076 163.194 57.6436 163.29 57.9156C163.386 58.1876 163.434 58.4796 163.434 58.7916V61.2756C163.434 61.4676 163.438 61.6716 163.446 61.8876C163.462 62.0956 163.486 62.2676 163.518 62.4036H162.498C162.434 62.1316 162.402 61.8596 162.402 61.5876H162.366C162.158 61.8916 161.894 62.1276 161.574 62.2956C161.262 62.4636 160.89 62.5476 160.458 62.5476C160.234 62.5476 159.998 62.5156 159.75 62.4516C159.51 62.3956 159.29 62.2996 159.09 62.1636C158.89 62.0276 158.722 61.8476 158.586 61.6236C158.458 61.3996 158.394 61.1236 158.394 60.7956C158.394 60.3636 158.51 60.0236 158.742 59.7756C158.974 59.5196 159.278 59.3276 159.654 59.1996C160.03 59.0636 160.454 58.9756 160.926 58.9356C161.398 58.8956 161.874 58.8756 162.354 58.8756V58.7196ZM162.078 59.6916C161.798 59.6916 161.506 59.7036 161.202 59.7276C160.906 59.7516 160.634 59.7996 160.386 59.8716C160.146 59.9436 159.946 60.0516 159.786 60.1956C159.626 60.3396 159.546 60.5316 159.546 60.7716C159.546 60.9396 159.578 61.0796 159.642 61.1916C159.714 61.3036 159.806 61.3956 159.918 61.4676C160.03 61.5396 160.154 61.5916 160.29 61.6236C160.426 61.6476 160.566 61.6596 160.71 61.6596C161.238 61.6596 161.642 61.5036 161.922 61.1916C162.21 60.8716 162.354 60.4716 162.354 59.9916V59.6916H162.078ZM167.985 57.6396H166.473V60.6036C166.473 60.9476 166.537 61.1956 166.665 61.3476C166.793 61.4916 166.997 61.5636 167.277 61.5636C167.381 61.5636 167.493 61.5516 167.613 61.5276C167.733 61.5036 167.841 61.4676 167.937 61.4196L167.973 62.3436C167.837 62.3916 167.685 62.4276 167.517 62.4516C167.357 62.4836 167.189 62.4996 167.013 62.4996C166.477 62.4996 166.065 62.3516 165.777 62.0556C165.497 61.7596 165.357 61.3156 165.357 60.7236V57.6396H164.265V56.7156H165.357V55.0836H166.473V56.7156H167.985V57.6396ZM173.314 59.0556C173.306 58.8316 173.266 58.6236 173.194 58.4316C173.13 58.2316 173.03 58.0596 172.894 57.9156C172.766 57.7716 172.602 57.6596 172.402 57.5796C172.21 57.4916 171.982 57.4476 171.718 57.4476C171.478 57.4476 171.25 57.4916 171.034 57.5796C170.826 57.6596 170.642 57.7716 170.482 57.9156C170.33 58.0596 170.202 58.2316 170.098 58.4316C170.002 58.6236 169.946 58.8316 169.93 59.0556H173.314ZM174.454 59.5116C174.454 59.5756 174.454 59.6396 174.454 59.7036C174.454 59.7676 174.45 59.8316 174.442 59.8956H169.93C169.938 60.1356 169.99 60.3636 170.086 60.5796C170.19 60.7876 170.326 60.9716 170.494 61.1316C170.662 61.2836 170.854 61.4036 171.07 61.4916C171.294 61.5796 171.53 61.6236 171.778 61.6236C172.162 61.6236 172.494 61.5396 172.774 61.3716C173.054 61.2036 173.274 60.9996 173.434 60.7596L174.226 61.3956C173.922 61.7956 173.562 62.0916 173.146 62.2836C172.738 62.4676 172.282 62.5596 171.778 62.5596C171.346 62.5596 170.946 62.4876 170.578 62.3436C170.21 62.1996 169.894 61.9996 169.63 61.7436C169.366 61.4796 169.158 61.1636 169.006 60.7956C168.854 60.4276 168.778 60.0196 168.778 59.5716C168.778 59.1316 168.85 58.7276 168.994 58.3596C169.146 57.9836 169.354 57.6636 169.618 57.3996C169.882 57.1356 170.194 56.9316 170.554 56.7876C170.914 56.6356 171.302 56.5596 171.718 56.5596C172.134 56.5596 172.51 56.6276 172.846 56.7636C173.19 56.8996 173.478 57.0956 173.71 57.3516C173.95 57.6076 174.134 57.9196 174.262 58.2876C174.39 58.6476 174.454 59.0556 174.454 59.5116ZM176.029 57.9396C176.029 57.7876 176.025 57.5916 176.017 57.3516C176.009 57.1116 175.997 56.8996 175.981 56.7156H177.049C177.065 56.8596 177.077 57.0276 177.085 57.2196C177.093 57.4036 177.097 57.5556 177.097 57.6756H177.133C177.293 57.3396 177.525 57.0716 177.829 56.8716C178.141 56.6636 178.489 56.5596 178.873 56.5596C179.049 56.5596 179.197 56.5756 179.317 56.6076L179.269 57.6516C179.109 57.6116 178.937 57.5916 178.753 57.5916C178.481 57.5916 178.245 57.6436 178.045 57.7476C177.845 57.8436 177.677 57.9756 177.541 58.1436C177.413 58.3116 177.317 58.5076 177.253 58.7316C177.189 58.9476 177.157 59.1756 177.157 59.4156V62.4036H176.029V57.9396ZM186.16 57.6396H184.648V60.6036C184.648 60.9476 184.712 61.1956 184.84 61.3476C184.968 61.4916 185.172 61.5636 185.452 61.5636C185.556 61.5636 185.668 61.5516 185.788 61.5276C185.908 61.5036 186.016 61.4676 186.112 61.4196L186.148 62.3436C186.012 62.3916 185.86 62.4276 185.692 62.4516C185.532 62.4836 185.364 62.4996 185.188 62.4996C184.652 62.4996 184.24 62.3516 183.952 62.0556C183.672 61.7596 183.532 61.3156 183.532 60.7236V57.6396H182.44V56.7156H183.532V55.0836H184.648V56.7156H186.16V57.6396ZM188.502 57.5796C188.638 57.2996 188.87 57.0596 189.198 56.8596C189.526 56.6596 189.894 56.5596 190.302 56.5596C190.67 56.5596 190.986 56.6236 191.25 56.7516C191.514 56.8716 191.734 57.0356 191.91 57.2436C192.086 57.4516 192.214 57.6956 192.294 57.9756C192.382 58.2556 192.426 58.5556 192.426 58.8756V62.4036H191.298V59.2596C191.298 59.0276 191.278 58.8076 191.238 58.5996C191.206 58.3916 191.142 58.2076 191.046 58.0476C190.95 57.8876 190.818 57.7596 190.65 57.6636C190.49 57.5676 190.278 57.5196 190.014 57.5196C189.566 57.5196 189.198 57.6916 188.91 58.0356C188.622 58.3716 188.478 58.8236 188.478 59.3916V62.4036H187.35V53.3316H188.478V57.5796H188.502ZM197.873 58.7196C197.873 58.2956 197.745 57.9836 197.489 57.7836C197.233 57.5756 196.893 57.4716 196.469 57.4716C196.149 57.4716 195.845 57.5356 195.557 57.6636C195.277 57.7836 195.041 57.9396 194.849 58.1316L194.249 57.4116C194.529 57.1476 194.869 56.9396 195.269 56.7876C195.677 56.6356 196.113 56.5596 196.577 56.5596C196.985 56.5596 197.337 56.6196 197.633 56.7396C197.937 56.8516 198.185 57.0076 198.377 57.2076C198.569 57.4076 198.713 57.6436 198.809 57.9156C198.905 58.1876 198.953 58.4796 198.953 58.7916V61.2756C198.953 61.4676 198.957 61.6716 198.965 61.8876C198.981 62.0956 199.005 62.2676 199.037 62.4036H198.017C197.953 62.1316 197.921 61.8596 197.921 61.5876H197.885C197.677 61.8916 197.413 62.1276 197.093 62.2956C196.781 62.4636 196.409 62.5476 195.977 62.5476C195.753 62.5476 195.517 62.5156 195.269 62.4516C195.029 62.3956 194.809 62.2996 194.609 62.1636C194.409 62.0276 194.241 61.8476 194.105 61.6236C193.977 61.3996 193.913 61.1236 193.913 60.7956C193.913 60.3636 194.029 60.0236 194.261 59.7756C194.493 59.5196 194.797 59.3276 195.173 59.1996C195.549 59.0636 195.973 58.9756 196.445 58.9356C196.917 58.8956 197.393 58.8756 197.873 58.8756V58.7196ZM197.597 59.6916C197.317 59.6916 197.025 59.7036 196.721 59.7276C196.425 59.7516 196.153 59.7996 195.905 59.8716C195.665 59.9436 195.465 60.0516 195.305 60.1956C195.145 60.3396 195.065 60.5316 195.065 60.7716C195.065 60.9396 195.097 61.0796 195.161 61.1916C195.233 61.3036 195.325 61.3956 195.437 61.4676C195.549 61.5396 195.673 61.5916 195.809 61.6236C195.945 61.6476 196.085 61.6596 196.229 61.6596C196.757 61.6596 197.161 61.5036 197.441 61.1916C197.729 60.8716 197.873 60.4716 197.873 59.9916V59.6916H197.597ZM201.857 56.7156C201.873 56.8596 201.885 57.0236 201.893 57.2076C201.901 57.3836 201.905 57.5316 201.905 57.6516H201.941C202.013 57.4996 202.109 57.3596 202.229 57.2316C202.357 57.0956 202.501 56.9796 202.661 56.8836C202.821 56.7796 202.997 56.6996 203.189 56.6436C203.381 56.5876 203.581 56.5596 203.789 56.5596C204.157 56.5596 204.473 56.6236 204.737 56.7516C205.001 56.8716 205.221 57.0356 205.397 57.2436C205.573 57.4516 205.701 57.6956 205.781 57.9756C205.869 58.2556 205.913 58.5556 205.913 58.8756V62.4036H204.785V59.2476C204.785 59.0156 204.765 58.7956 204.725 58.5876C204.693 58.3796 204.629 58.1956 204.533 58.0356C204.437 57.8756 204.305 57.7476 204.137 57.6516C203.969 57.5556 203.753 57.5076 203.489 57.5076C203.041 57.5076 202.673 57.6796 202.385 58.0236C202.105 58.3596 201.965 58.8116 201.965 59.3796V62.4036H200.837V57.9396C200.837 57.7876 200.833 57.5916 200.825 57.3516C200.817 57.1116 200.805 56.8996 200.789 56.7156H201.857Z",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.134 57.009L218.781 60.7276L215.626 57.009",
    stroke: "#73767D",
    strokeWidth: 0.697231,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 233.495,
    y: 44.7522,
    width: 49.3028,
    height: 27.3028,
    rx: 2.44032,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 233.495,
    y: 44.7522,
    width: 49.3028,
    height: 27.3028,
    rx: 2.44032,
    stroke: "#CCCCCC",
    strokeWidth: 0.697233
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.272 62.9341H242.108V55.8541L240.5 57.1981L239.816 56.3941L242.228 54.4381H243.272V62.9341ZM249.436 54.2221C249.94 54.2221 250.372 54.3381 250.732 54.5701C251.1 54.8021 251.4 55.1221 251.632 55.5301C251.872 55.9301 252.048 56.4021 252.16 56.9461C252.272 57.4901 252.328 58.0701 252.328 58.6861C252.328 59.3101 252.272 59.8941 252.16 60.4381C252.048 60.9741 251.872 61.4461 251.632 61.8541C251.4 62.2541 251.1 62.5701 250.732 62.8021C250.372 63.0341 249.94 63.1501 249.436 63.1501C248.932 63.1501 248.496 63.0341 248.128 62.8021C247.76 62.5701 247.456 62.2541 247.216 61.8541C246.984 61.4461 246.812 60.9741 246.7 60.4381C246.588 59.8941 246.532 59.3101 246.532 58.6861C246.532 58.0701 246.588 57.4901 246.7 56.9461C246.812 56.4021 246.984 55.9301 247.216 55.5301C247.456 55.1221 247.76 54.8021 248.128 54.5701C248.496 54.3381 248.932 54.2221 249.436 54.2221ZM249.436 55.1941C249.084 55.1941 248.796 55.3101 248.572 55.5421C248.348 55.7661 248.172 56.0541 248.044 56.4061C247.924 56.7501 247.84 57.1261 247.792 57.5341C247.744 57.9421 247.72 58.3261 247.72 58.6861C247.72 59.0461 247.744 59.4301 247.792 59.8381C247.84 60.2461 247.924 60.6221 248.044 60.9661C248.172 61.3101 248.348 61.5981 248.572 61.8301C248.796 62.0541 249.084 62.1661 249.436 62.1661C249.78 62.1661 250.06 62.0541 250.276 61.8301C250.5 61.5981 250.676 61.3101 250.804 60.9661C250.932 60.6221 251.02 60.2461 251.068 59.8381C251.116 59.4301 251.14 59.0461 251.14 58.6861C251.14 58.3261 251.116 57.9421 251.068 57.5341C251.02 57.1261 250.932 56.7501 250.804 56.4061C250.676 56.0541 250.5 55.7661 250.276 55.5421C250.06 55.3101 249.78 55.1941 249.436 55.1941ZM256.573 54.2221C257.077 54.2221 257.509 54.3381 257.869 54.5701C258.237 54.8021 258.537 55.1221 258.769 55.5301C259.009 55.9301 259.185 56.4021 259.297 56.9461C259.409 57.4901 259.465 58.0701 259.465 58.6861C259.465 59.3101 259.409 59.8941 259.297 60.4381C259.185 60.9741 259.009 61.4461 258.769 61.8541C258.537 62.2541 258.237 62.5701 257.869 62.8021C257.509 63.0341 257.077 63.1501 256.573 63.1501C256.069 63.1501 255.633 63.0341 255.265 62.8021C254.897 62.5701 254.593 62.2541 254.353 61.8541C254.121 61.4461 253.949 60.9741 253.837 60.4381C253.725 59.8941 253.669 59.3101 253.669 58.6861C253.669 58.0701 253.725 57.4901 253.837 56.9461C253.949 56.4021 254.121 55.9301 254.353 55.5301C254.593 55.1221 254.897 54.8021 255.265 54.5701C255.633 54.3381 256.069 54.2221 256.573 54.2221ZM256.573 55.1941C256.221 55.1941 255.933 55.3101 255.709 55.5421C255.485 55.7661 255.309 56.0541 255.181 56.4061C255.061 56.7501 254.977 57.1261 254.929 57.5341C254.881 57.9421 254.857 58.3261 254.857 58.6861C254.857 59.0461 254.881 59.4301 254.929 59.8381C254.977 60.2461 255.061 60.6221 255.181 60.9661C255.309 61.3101 255.485 61.5981 255.709 61.8301C255.933 62.0541 256.221 62.1661 256.573 62.1661C256.917 62.1661 257.197 62.0541 257.413 61.8301C257.637 61.5981 257.813 61.3101 257.941 60.9661C258.069 60.6221 258.157 60.2461 258.205 59.8381C258.253 59.4301 258.277 59.0461 258.277 58.6861C258.277 58.3261 258.253 57.9421 258.205 57.5341C258.157 57.1261 258.069 56.7501 257.941 56.4061C257.813 56.0541 257.637 55.7661 257.413 55.5421C257.197 55.3101 256.917 55.1941 256.573 55.1941Z",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.664 58.1821C268.808 57.8781 269.036 57.6221 269.348 57.4141C269.668 57.1981 270.044 57.0901 270.476 57.0901C270.86 57.0901 271.204 57.1781 271.508 57.3541C271.82 57.5301 272.064 57.8221 272.24 58.2301C272.432 57.8621 272.7 57.5821 273.044 57.3901C273.388 57.1901 273.764 57.0901 274.172 57.0901C274.54 57.0901 274.856 57.1541 275.12 57.2821C275.384 57.4021 275.604 57.5661 275.78 57.7741C275.956 57.9821 276.084 58.2261 276.164 58.5061C276.252 58.7861 276.296 59.0861 276.296 59.4061V62.9341H275.168V59.7781C275.168 59.5461 275.148 59.3261 275.108 59.1181C275.068 58.9101 275 58.7261 274.904 58.5661C274.808 58.4061 274.68 58.2781 274.52 58.1821C274.36 58.0861 274.156 58.0381 273.908 58.0381C273.652 58.0381 273.432 58.0941 273.248 58.2061C273.064 58.3101 272.912 58.4501 272.792 58.6261C272.68 58.7941 272.596 58.9861 272.54 59.2021C272.492 59.4181 272.468 59.6381 272.468 59.8621V62.9341H271.34V59.5501C271.34 59.3261 271.32 59.1221 271.28 58.9381C271.24 58.7541 271.172 58.5981 271.076 58.4701C270.98 58.3341 270.856 58.2301 270.704 58.1581C270.552 58.0781 270.364 58.0381 270.14 58.0381C269.724 58.0381 269.376 58.2101 269.096 58.5541C268.824 58.8901 268.688 59.3421 268.688 59.9101V62.9341H267.56V58.4701C267.56 58.3181 267.556 58.1221 267.548 57.8821C267.54 57.6421 267.528 57.4301 267.512 57.2461H268.58C268.596 57.3901 268.608 57.5541 268.616 57.7381C268.624 57.9141 268.628 58.0621 268.628 58.1821H268.664ZM279.341 62.9341H278.213V57.2461H279.341V62.9341ZM279.533 55.1941C279.533 55.4021 279.457 55.5741 279.305 55.7101C279.161 55.8461 278.985 55.9141 278.777 55.9141C278.569 55.9141 278.393 55.8461 278.249 55.7101C278.105 55.5661 278.033 55.3941 278.033 55.1941C278.033 54.9861 278.105 54.8141 278.249 54.6781C278.393 54.5341 278.569 54.4621 278.777 54.4621C278.985 54.4621 279.161 54.5341 279.305 54.6781C279.457 54.8141 279.533 54.9861 279.533 55.1941Z",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.055 18.2127C284.443 17.4702 285.505 17.4699 285.893 18.2122L287.67 21.615C287.719 21.7088 287.795 21.7854 287.889 21.8344L291.293 23.6124C292.036 24.0001 292.035 25.0623 291.293 25.4497L287.889 27.2259C287.795 27.2749 287.719 27.3515 287.67 27.4455L285.893 30.8495C285.505 31.5921 284.443 31.5918 284.055 30.849L282.281 27.4457C282.232 27.3516 282.155 27.2749 282.061 27.2258L278.656 25.4498C277.913 25.0625 277.913 23.9998 278.655 23.6123L282.062 21.8345C282.156 21.7854 282.232 21.7087 282.281 21.6147L284.055 18.2127Z",
    fill: "#FFCC1F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.114 29.2874C294.306 28.9194 294.833 28.9193 295.025 29.2871L296.155 31.4515C296.179 31.498 296.217 31.5359 296.264 31.5602L298.429 32.6911C298.797 32.8831 298.797 33.4095 298.429 33.6014L296.264 34.7311C296.217 34.7554 296.179 34.7934 296.155 34.8399L295.025 37.0052C294.833 37.3731 294.306 37.373 294.114 37.0049L292.986 34.8401C292.962 34.7934 292.923 34.7554 292.877 34.7311L290.711 33.6015C290.343 33.4096 290.343 32.883 290.71 32.691L292.877 31.5602C292.924 31.5359 292.962 31.4979 292.986 31.4514L294.114 29.2874Z",
    fill: "#FFCC1F"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1420_6457)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip29_1420_6457)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 157,
    height: 27,
    transform: "translate(32.6016 72.573)",
    fill: "#EDF6FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.5766 90.073H40.7126V82.345H37.8686V81.577H44.4206V82.345H41.5766V90.073ZM50.0799 87.265C50.0799 87.689 50.0039 88.081 49.8519 88.441C49.7079 88.801 49.5039 89.113 49.2399 89.377C48.9759 89.641 48.6599 89.849 48.2919 90.001C47.9239 90.145 47.5199 90.217 47.0799 90.217C46.6479 90.217 46.2479 90.145 45.8799 90.001C45.5119 89.849 45.1959 89.641 44.9319 89.377C44.6679 89.113 44.4599 88.801 44.3079 88.441C44.1639 88.081 44.0919 87.689 44.0919 87.265C44.0919 86.841 44.1639 86.449 44.3079 86.089C44.4599 85.729 44.6679 85.417 44.9319 85.153C45.1959 84.889 45.5119 84.685 45.8799 84.541C46.2479 84.389 46.6479 84.313 47.0799 84.313C47.5199 84.313 47.9239 84.389 48.2919 84.541C48.6599 84.685 48.9759 84.889 49.2399 85.153C49.5039 85.417 49.7079 85.729 49.8519 86.089C50.0039 86.449 50.0799 86.841 50.0799 87.265ZM49.2159 87.265C49.2159 86.953 49.1639 86.661 49.0599 86.389C48.9639 86.109 48.8239 85.869 48.6399 85.669C48.4559 85.461 48.2319 85.297 47.9679 85.177C47.7039 85.057 47.4079 84.997 47.0799 84.997C46.7519 84.997 46.4559 85.057 46.1919 85.177C45.9359 85.297 45.7159 85.461 45.5319 85.669C45.3479 85.869 45.2039 86.109 45.0999 86.389C45.0039 86.661 44.9559 86.953 44.9559 87.265C44.9559 87.577 45.0039 87.873 45.0999 88.153C45.2039 88.425 45.3479 88.665 45.5319 88.873C45.7159 89.073 45.9359 89.233 46.1919 89.353C46.4559 89.465 46.7519 89.521 47.0799 89.521C47.4079 89.521 47.7039 89.465 47.9679 89.353C48.2319 89.233 48.4559 89.073 48.6399 88.873C48.8239 88.665 48.9639 88.425 49.0599 88.153C49.1639 87.873 49.2159 87.577 49.2159 87.265ZM54.3679 85.141H52.7839V88.417C52.7839 88.625 52.8039 88.797 52.8439 88.933C52.8839 89.069 52.9399 89.177 53.0119 89.257C53.0919 89.329 53.1839 89.381 53.2879 89.413C53.3919 89.437 53.5039 89.449 53.6239 89.449C53.7359 89.449 53.8519 89.433 53.9719 89.401C54.0999 89.369 54.2199 89.325 54.3319 89.269L54.3679 89.977C54.2239 90.033 54.0719 90.073 53.9119 90.097C53.7599 90.129 53.5919 90.145 53.4079 90.145C53.2559 90.145 53.0959 90.125 52.9279 90.085C52.7599 90.045 52.6039 89.969 52.4599 89.857C52.3159 89.745 52.1959 89.593 52.0999 89.401C52.0119 89.209 51.9679 88.957 51.9679 88.645V85.141H50.8039V84.457H51.9679V82.873H52.7839V84.457H54.3679V85.141ZM59.1845 86.449C59.1845 85.961 59.0565 85.597 58.8005 85.357C58.5445 85.117 58.1725 84.997 57.6845 84.997C57.3485 84.997 57.0365 85.057 56.7485 85.177C56.4605 85.297 56.2165 85.457 56.0165 85.657L55.5605 85.117C55.7925 84.885 56.0965 84.693 56.4725 84.541C56.8565 84.389 57.2885 84.313 57.7685 84.313C58.0725 84.313 58.3565 84.357 58.6205 84.445C58.8845 84.525 59.1165 84.649 59.3165 84.817C59.5165 84.985 59.6725 85.197 59.7845 85.453C59.8965 85.709 59.9525 86.009 59.9525 86.353V88.813C59.9525 89.029 59.9605 89.253 59.9765 89.485C59.9925 89.717 60.0165 89.913 60.0485 90.073H59.3165C59.2925 89.937 59.2725 89.789 59.2565 89.629C59.2405 89.469 59.2325 89.313 59.2325 89.161H59.2085C58.9525 89.537 58.6605 89.809 58.3325 89.977C58.0125 90.137 57.6245 90.217 57.1685 90.217C56.9525 90.217 56.7285 90.185 56.4965 90.121C56.2725 90.065 56.0645 89.969 55.8725 89.833C55.6885 89.697 55.5325 89.521 55.4045 89.305C55.2845 89.089 55.2245 88.825 55.2245 88.513C55.2245 88.081 55.3325 87.741 55.5485 87.493C55.7725 87.237 56.0685 87.049 56.4365 86.929C56.8045 86.801 57.2245 86.721 57.6965 86.689C58.1765 86.649 58.6725 86.629 59.1845 86.629V86.449ZM58.9445 87.265C58.6085 87.265 58.2685 87.281 57.9245 87.313C57.5885 87.337 57.2805 87.393 57.0005 87.481C56.7285 87.561 56.5045 87.681 56.3285 87.841C56.1525 88.001 56.0645 88.213 56.0645 88.477C56.0645 88.677 56.1005 88.845 56.1725 88.981C56.2525 89.117 56.3565 89.229 56.4845 89.317C56.6125 89.397 56.7525 89.457 56.9045 89.497C57.0645 89.529 57.2245 89.545 57.3845 89.545C57.6725 89.545 57.9285 89.497 58.1525 89.401C58.3765 89.297 58.5645 89.161 58.7165 88.993C58.8685 88.817 58.9845 88.617 59.0645 88.393C59.1445 88.169 59.1845 87.933 59.1845 87.685V87.265H58.9445ZM62.8946 90.073H62.0786V81.001H62.8946V90.073ZM68.882 85.417C69.042 85.089 69.286 84.825 69.614 84.625C69.95 84.417 70.322 84.313 70.73 84.313C70.882 84.313 71.038 84.329 71.198 84.361C71.366 84.393 71.526 84.457 71.678 84.553C71.838 84.641 71.982 84.761 72.11 84.913C72.246 85.065 72.362 85.261 72.458 85.501C72.65 85.117 72.91 84.825 73.238 84.625C73.574 84.417 73.97 84.313 74.426 84.313C75.138 84.313 75.67 84.525 76.022 84.949C76.382 85.373 76.562 85.933 76.562 86.629V90.073H75.746V86.965C75.746 86.373 75.634 85.897 75.41 85.537C75.194 85.177 74.822 84.997 74.294 84.997C73.998 84.997 73.746 85.057 73.538 85.177C73.338 85.297 73.174 85.457 73.046 85.657C72.926 85.849 72.838 86.069 72.782 86.317C72.726 86.565 72.698 86.821 72.698 87.085V90.073H71.882V86.797C71.882 86.525 71.862 86.277 71.822 86.053C71.782 85.829 71.71 85.641 71.606 85.489C71.51 85.329 71.374 85.209 71.198 85.129C71.022 85.041 70.798 84.997 70.526 84.997C70.334 84.997 70.138 85.041 69.938 85.129C69.746 85.217 69.57 85.353 69.41 85.537C69.258 85.713 69.134 85.941 69.038 86.221C68.942 86.493 68.894 86.817 68.894 87.193V90.073H68.078V85.693C68.078 85.541 68.074 85.345 68.066 85.105C68.058 84.865 68.046 84.649 68.03 84.457H68.81C68.826 84.609 68.838 84.777 68.846 84.961C68.854 85.145 68.858 85.297 68.858 85.417H68.882ZM79.4998 90.073H78.6838V84.457H79.4998V90.073ZM79.6678 82.297C79.6678 82.465 79.6078 82.605 79.4878 82.717C79.3678 82.821 79.2358 82.873 79.0918 82.873C78.9478 82.873 78.8158 82.821 78.6958 82.717C78.5758 82.605 78.5158 82.465 78.5158 82.297C78.5158 82.129 78.5758 81.993 78.6958 81.889C78.8158 81.777 78.9478 81.721 79.0918 81.721C79.2358 81.721 79.3678 81.777 79.4878 81.889C79.6078 81.993 79.6678 82.129 79.6678 82.297ZM82.5118 90.073H81.6958V81.001H82.5118V90.073ZM88.9792 86.833C88.9552 86.305 88.7832 85.869 88.4632 85.525C88.1512 85.173 87.7032 84.997 87.1192 84.997C86.8472 84.997 86.5952 85.049 86.3632 85.153C86.1312 85.249 85.9272 85.385 85.7512 85.561C85.5752 85.729 85.4352 85.925 85.3312 86.149C85.2272 86.365 85.1672 86.593 85.1512 86.833H88.9792ZM89.8072 87.097C89.8072 87.153 89.8072 87.213 89.8072 87.277C89.8072 87.341 89.8032 87.409 89.7952 87.481H85.1392C85.1472 87.761 85.2032 88.025 85.3072 88.273C85.4112 88.521 85.5552 88.737 85.7392 88.921C85.9232 89.105 86.1392 89.253 86.3872 89.365C86.6352 89.469 86.9032 89.521 87.1912 89.521C87.6152 89.521 87.9792 89.425 88.2832 89.233C88.5952 89.033 88.8312 88.805 88.9912 88.549L89.6032 89.029C89.2672 89.453 88.8952 89.757 88.4872 89.941C88.0872 90.125 87.6552 90.217 87.1912 90.217C86.7752 90.217 86.3872 90.145 86.0272 90.001C85.6752 89.849 85.3712 89.641 85.1152 89.377C84.8592 89.113 84.6552 88.801 84.5032 88.441C84.3592 88.081 84.2872 87.689 84.2872 87.265C84.2872 86.841 84.3592 86.449 84.5032 86.089C84.6472 85.729 84.8472 85.417 85.1032 85.153C85.3592 84.889 85.6592 84.685 86.0032 84.541C86.3472 84.389 86.7192 84.313 87.1192 84.313C87.5592 84.313 87.9472 84.389 88.2832 84.541C88.6192 84.685 88.8992 84.885 89.1232 85.141C89.3472 85.389 89.5152 85.681 89.6272 86.017C89.7472 86.353 89.8072 86.713 89.8072 87.097ZM94.5504 85.789C94.4304 85.557 94.2464 85.369 93.9984 85.225C93.7584 85.073 93.4824 84.997 93.1704 84.997C93.0264 84.997 92.8824 85.013 92.7384 85.045C92.5944 85.077 92.4664 85.129 92.3544 85.201C92.2424 85.273 92.1504 85.365 92.0784 85.477C92.0144 85.589 91.9824 85.721 91.9824 85.873C91.9824 86.137 92.0904 86.341 92.3064 86.485C92.5224 86.621 92.8624 86.737 93.3264 86.833C93.9904 86.969 94.4784 87.169 94.7904 87.433C95.1104 87.689 95.2704 88.037 95.2704 88.477C95.2704 88.797 95.2064 89.069 95.0784 89.293C94.9584 89.509 94.7984 89.689 94.5984 89.833C94.3984 89.969 94.1704 90.065 93.9144 90.121C93.6664 90.185 93.4144 90.217 93.1584 90.217C92.7344 90.217 92.3224 90.129 91.9224 89.953C91.5224 89.777 91.1944 89.501 90.9384 89.125L91.5864 88.645C91.7304 88.893 91.9424 89.101 92.2224 89.269C92.5024 89.437 92.8104 89.521 93.1464 89.521C93.3224 89.521 93.4904 89.505 93.6504 89.473C93.8104 89.441 93.9504 89.385 94.0704 89.305C94.1904 89.225 94.2864 89.125 94.3584 89.005C94.4304 88.877 94.4664 88.721 94.4664 88.537C94.4664 88.241 94.3224 88.021 94.0344 87.877C93.7544 87.725 93.3464 87.585 92.8104 87.457C92.6424 87.417 92.4624 87.369 92.2704 87.313C92.0864 87.249 91.9144 87.161 91.7544 87.049C91.5944 86.929 91.4624 86.781 91.3584 86.605C91.2544 86.429 91.2024 86.209 91.2024 85.945C91.2024 85.657 91.2584 85.413 91.3704 85.213C91.4824 85.005 91.6304 84.837 91.8144 84.709C92.0064 84.573 92.2224 84.473 92.4624 84.409C92.7024 84.345 92.9504 84.313 93.2064 84.313C93.5984 84.313 93.9784 84.401 94.3464 84.577C94.7144 84.753 94.9904 85.001 95.1744 85.321L94.5504 85.789Z",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 188,
    height: 27,
    transform: "translate(32.6016 99.573)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.8526 108.577H41.2526C41.6846 108.577 42.0766 108.625 42.4286 108.721C42.7806 108.809 43.0806 108.949 43.3286 109.141C43.5846 109.325 43.7806 109.561 43.9166 109.849C44.0526 110.129 44.1206 110.461 44.1206 110.845C44.1206 111.229 44.0486 111.565 43.9046 111.853C43.7686 112.133 43.5726 112.369 43.3166 112.561C43.0686 112.745 42.7646 112.885 42.4046 112.981C42.0526 113.077 41.6606 113.125 41.2286 113.125H39.7166V117.073H38.8526V108.577ZM39.7166 112.393H41.1806C41.8606 112.393 42.3766 112.261 42.7286 111.997C43.0806 111.733 43.2566 111.349 43.2566 110.845C43.2566 110.317 43.0726 109.933 42.7046 109.693C42.3446 109.445 41.8366 109.321 41.1806 109.321H39.7166V112.393ZM48.5907 113.449C48.5907 112.961 48.4627 112.597 48.2067 112.357C47.9507 112.117 47.5787 111.997 47.0907 111.997C46.7547 111.997 46.4427 112.057 46.1547 112.177C45.8667 112.297 45.6227 112.457 45.4227 112.657L44.9667 112.117C45.1987 111.885 45.5027 111.693 45.8787 111.541C46.2627 111.389 46.6947 111.313 47.1747 111.313C47.4787 111.313 47.7627 111.357 48.0267 111.445C48.2907 111.525 48.5227 111.649 48.7227 111.817C48.9227 111.985 49.0787 112.197 49.1907 112.453C49.3027 112.709 49.3587 113.009 49.3587 113.353V115.813C49.3587 116.029 49.3667 116.253 49.3827 116.485C49.3987 116.717 49.4227 116.913 49.4547 117.073H48.7227C48.6987 116.937 48.6787 116.789 48.6627 116.629C48.6467 116.469 48.6387 116.313 48.6387 116.161H48.6147C48.3587 116.537 48.0667 116.809 47.7387 116.977C47.4187 117.137 47.0307 117.217 46.5747 117.217C46.3587 117.217 46.1347 117.185 45.9027 117.121C45.6787 117.065 45.4707 116.969 45.2787 116.833C45.0947 116.697 44.9387 116.521 44.8107 116.305C44.6907 116.089 44.6307 115.825 44.6307 115.513C44.6307 115.081 44.7387 114.741 44.9547 114.493C45.1787 114.237 45.4747 114.049 45.8427 113.929C46.2107 113.801 46.6307 113.721 47.1027 113.689C47.5827 113.649 48.0787 113.629 48.5907 113.629V113.449ZM48.3507 114.265C48.0147 114.265 47.6747 114.281 47.3307 114.313C46.9947 114.337 46.6867 114.393 46.4067 114.481C46.1347 114.561 45.9107 114.681 45.7347 114.841C45.5587 115.001 45.4707 115.213 45.4707 115.477C45.4707 115.677 45.5067 115.845 45.5787 115.981C45.6587 116.117 45.7627 116.229 45.8907 116.317C46.0187 116.397 46.1587 116.457 46.3107 116.497C46.4707 116.529 46.6307 116.545 46.7907 116.545C47.0787 116.545 47.3347 116.497 47.5587 116.401C47.7827 116.297 47.9707 116.161 48.1227 115.993C48.2747 115.817 48.3907 115.617 48.4707 115.393C48.5507 115.169 48.5907 114.933 48.5907 114.685V114.265H48.3507ZM53.3929 116.197H53.4169L55.1569 111.457H56.0449L53.2489 118.525C53.0809 118.957 52.8649 119.301 52.6009 119.557C52.3449 119.821 51.9729 119.953 51.4849 119.953C51.2369 119.953 50.9929 119.929 50.7529 119.881L50.8369 119.137C51.0289 119.201 51.2289 119.233 51.4369 119.233C51.7169 119.233 51.9369 119.145 52.0969 118.969C52.2569 118.801 52.3969 118.557 52.5169 118.237L52.9729 117.061L50.5729 111.457H51.4849L53.3929 116.197ZM61.1362 119.953H60.3202V111.457H61.1362V112.429H61.1722C61.4042 112.061 61.7122 111.785 62.0962 111.601C62.4882 111.409 62.8842 111.313 63.2842 111.313C63.7242 111.313 64.1202 111.389 64.4722 111.541C64.8322 111.693 65.1362 111.901 65.3842 112.165C65.6402 112.429 65.8362 112.741 65.9722 113.101C66.1162 113.461 66.1882 113.849 66.1882 114.265C66.1882 114.681 66.1162 115.069 65.9722 115.429C65.8362 115.789 65.6402 116.101 65.3842 116.365C65.1362 116.629 64.8322 116.837 64.4722 116.989C64.1202 117.141 63.7242 117.217 63.2842 117.217C62.8842 117.217 62.4882 117.125 62.0962 116.941C61.7122 116.749 61.4042 116.477 61.1722 116.125H61.1362V119.953ZM65.3242 114.265C65.3242 113.953 65.2762 113.661 65.1802 113.389C65.0842 113.109 64.9442 112.869 64.7602 112.669C64.5842 112.461 64.3642 112.297 64.1002 112.177C63.8362 112.057 63.5362 111.997 63.2002 111.997C62.8882 111.997 62.6002 112.057 62.3362 112.177C62.0722 112.289 61.8442 112.449 61.6522 112.657C61.4602 112.857 61.3082 113.097 61.1962 113.377C61.0922 113.649 61.0402 113.945 61.0402 114.265C61.0402 114.585 61.0922 114.885 61.1962 115.165C61.3082 115.437 61.4602 115.673 61.6522 115.873C61.8442 116.073 62.0722 116.233 62.3362 116.353C62.6002 116.465 62.8882 116.521 63.2002 116.521C63.5362 116.521 63.8362 116.465 64.1002 116.353C64.3642 116.233 64.5842 116.073 64.7602 115.873C64.9442 115.665 65.0842 115.425 65.1802 115.153C65.2762 114.873 65.3242 114.577 65.3242 114.265ZM72.2214 113.833C72.1974 113.305 72.0254 112.869 71.7054 112.525C71.3934 112.173 70.9454 111.997 70.3614 111.997C70.0894 111.997 69.8374 112.049 69.6054 112.153C69.3734 112.249 69.1694 112.385 68.9934 112.561C68.8174 112.729 68.6774 112.925 68.5734 113.149C68.4694 113.365 68.4094 113.593 68.3934 113.833H72.2214ZM73.0494 114.097C73.0494 114.153 73.0494 114.213 73.0494 114.277C73.0494 114.341 73.0454 114.409 73.0374 114.481H68.3814C68.3894 114.761 68.4454 115.025 68.5494 115.273C68.6534 115.521 68.7974 115.737 68.9814 115.921C69.1654 116.105 69.3814 116.253 69.6294 116.365C69.8774 116.469 70.1454 116.521 70.4334 116.521C70.8574 116.521 71.2214 116.425 71.5254 116.233C71.8374 116.033 72.0734 115.805 72.2334 115.549L72.8454 116.029C72.5094 116.453 72.1374 116.757 71.7294 116.941C71.3294 117.125 70.8974 117.217 70.4334 117.217C70.0174 117.217 69.6294 117.145 69.2694 117.001C68.9174 116.849 68.6134 116.641 68.3574 116.377C68.1014 116.113 67.8974 115.801 67.7454 115.441C67.6014 115.081 67.5294 114.689 67.5294 114.265C67.5294 113.841 67.6014 113.449 67.7454 113.089C67.8894 112.729 68.0894 112.417 68.3454 112.153C68.6014 111.889 68.9014 111.685 69.2454 111.541C69.5894 111.389 69.9614 111.313 70.3614 111.313C70.8014 111.313 71.1894 111.389 71.5254 111.541C71.8614 111.685 72.1414 111.885 72.3654 112.141C72.5894 112.389 72.7574 112.681 72.8694 113.017C72.9894 113.353 73.0494 113.713 73.0494 114.097ZM74.8046 112.693C74.8046 112.541 74.8006 112.345 74.7926 112.105C74.7846 111.865 74.7726 111.649 74.7566 111.457H75.5366C75.5526 111.609 75.5646 111.777 75.5726 111.961C75.5806 112.145 75.5846 112.297 75.5846 112.417H75.6086C75.7686 112.089 76.0086 111.825 76.3286 111.625C76.6486 111.417 77.0086 111.313 77.4086 111.313C77.5126 111.313 77.6046 111.317 77.6846 111.325C77.7726 111.333 77.8606 111.349 77.9486 111.373L77.8406 112.141C77.7926 112.125 77.7126 112.109 77.6006 112.093C77.4886 112.077 77.3766 112.069 77.2646 112.069C77.0486 112.069 76.8406 112.109 76.6406 112.189C76.4406 112.269 76.2646 112.397 76.1126 112.573C75.9686 112.741 75.8486 112.961 75.7526 113.233C75.6646 113.497 75.6206 113.817 75.6206 114.193V117.073H74.8046V112.693ZM79.9568 117.073H79.1408V111.457H79.9568V117.073ZM80.1248 109.297C80.1248 109.465 80.0648 109.605 79.9448 109.717C79.8248 109.821 79.6928 109.873 79.5488 109.873C79.4048 109.873 79.2728 109.821 79.1528 109.717C79.0328 109.605 78.9728 109.465 78.9728 109.297C78.9728 109.129 79.0328 108.993 79.1528 108.889C79.2728 108.777 79.4048 108.721 79.5488 108.721C79.6928 108.721 79.8248 108.777 79.9448 108.889C80.0648 108.993 80.1248 109.129 80.1248 109.297ZM87.7088 114.265C87.7088 114.689 87.6328 115.081 87.4808 115.441C87.3368 115.801 87.1328 116.113 86.8688 116.377C86.6048 116.641 86.2888 116.849 85.9208 117.001C85.5528 117.145 85.1488 117.217 84.7088 117.217C84.2768 117.217 83.8768 117.145 83.5088 117.001C83.1408 116.849 82.8248 116.641 82.5608 116.377C82.2968 116.113 82.0888 115.801 81.9368 115.441C81.7928 115.081 81.7208 114.689 81.7208 114.265C81.7208 113.841 81.7928 113.449 81.9368 113.089C82.0888 112.729 82.2968 112.417 82.5608 112.153C82.8248 111.889 83.1408 111.685 83.5088 111.541C83.8768 111.389 84.2768 111.313 84.7088 111.313C85.1488 111.313 85.5528 111.389 85.9208 111.541C86.2888 111.685 86.6048 111.889 86.8688 112.153C87.1328 112.417 87.3368 112.729 87.4808 113.089C87.6328 113.449 87.7088 113.841 87.7088 114.265ZM86.8448 114.265C86.8448 113.953 86.7928 113.661 86.6888 113.389C86.5928 113.109 86.4528 112.869 86.2688 112.669C86.0848 112.461 85.8608 112.297 85.5968 112.177C85.3328 112.057 85.0368 111.997 84.7088 111.997C84.3808 111.997 84.0848 112.057 83.8208 112.177C83.5648 112.297 83.3448 112.461 83.1608 112.669C82.9768 112.869 82.8328 113.109 82.7288 113.389C82.6328 113.661 82.5848 113.953 82.5848 114.265C82.5848 114.577 82.6328 114.873 82.7288 115.153C82.8328 115.425 82.9768 115.665 83.1608 115.873C83.3448 116.073 83.5648 116.233 83.8208 116.353C84.0848 116.465 84.3808 116.521 84.7088 116.521C85.0368 116.521 85.3328 116.465 85.5968 116.353C85.8608 116.233 86.0848 116.073 86.2688 115.873C86.4528 115.665 86.5928 115.425 86.6888 115.153C86.7928 114.873 86.8448 114.577 86.8448 114.265ZM94.0848 116.125C93.8448 116.485 93.5328 116.757 93.1488 116.941C92.7648 117.125 92.3688 117.217 91.9608 117.217C91.5208 117.217 91.1208 117.141 90.7608 116.989C90.4088 116.837 90.1048 116.629 89.8488 116.365C89.6008 116.101 89.4048 115.789 89.2608 115.429C89.1248 115.069 89.0568 114.681 89.0568 114.265C89.0568 113.849 89.1248 113.461 89.2608 113.101C89.4048 112.741 89.6008 112.429 89.8488 112.165C90.1048 111.901 90.4088 111.693 90.7608 111.541C91.1208 111.389 91.5208 111.313 91.9608 111.313C92.3688 111.313 92.7648 111.409 93.1488 111.601C93.5328 111.785 93.8448 112.061 94.0848 112.429H94.1088V108.001H94.9248V117.073H94.1088V116.125H94.0848ZM89.9208 114.265C89.9208 114.577 89.9688 114.873 90.0648 115.153C90.1608 115.425 90.2968 115.665 90.4728 115.873C90.6568 116.073 90.8808 116.233 91.1448 116.353C91.4088 116.465 91.7088 116.521 92.0448 116.521C92.3568 116.521 92.6448 116.465 92.9088 116.353C93.1728 116.233 93.4008 116.073 93.5928 115.873C93.7848 115.673 93.9328 115.437 94.0368 115.165C94.1488 114.885 94.2048 114.585 94.2048 114.265C94.2048 113.945 94.1488 113.649 94.0368 113.377C93.9328 113.097 93.7848 112.857 93.5928 112.657C93.4008 112.449 93.1728 112.289 92.9088 112.177C92.6448 112.057 92.3568 111.997 92.0448 111.997C91.7088 111.997 91.4088 112.057 91.1448 112.177C90.8808 112.297 90.6568 112.461 90.4728 112.669C90.2968 112.869 90.1608 113.109 90.0648 113.389C89.9688 113.661 89.9208 113.953 89.9208 114.265ZM102.637 112.141H101.053V115.417C101.053 115.625 101.073 115.797 101.113 115.933C101.153 116.069 101.209 116.177 101.281 116.257C101.361 116.329 101.453 116.381 101.557 116.413C101.661 116.437 101.773 116.449 101.893 116.449C102.005 116.449 102.121 116.433 102.241 116.401C102.369 116.369 102.489 116.325 102.601 116.269L102.637 116.977C102.493 117.033 102.341 117.073 102.181 117.097C102.029 117.129 101.861 117.145 101.677 117.145C101.525 117.145 101.365 117.125 101.197 117.085C101.029 117.045 100.873 116.969 100.729 116.857C100.585 116.745 100.465 116.593 100.369 116.401C100.281 116.209 100.237 115.957 100.237 115.645V112.141H99.0734V111.457H100.237V109.873H101.053V111.457H102.637V112.141ZM109.494 114.265C109.494 114.689 109.418 115.081 109.266 115.441C109.122 115.801 108.918 116.113 108.654 116.377C108.39 116.641 108.074 116.849 107.706 117.001C107.338 117.145 106.934 117.217 106.494 117.217C106.062 117.217 105.662 117.145 105.294 117.001C104.926 116.849 104.61 116.641 104.346 116.377C104.082 116.113 103.874 115.801 103.722 115.441C103.578 115.081 103.506 114.689 103.506 114.265C103.506 113.841 103.578 113.449 103.722 113.089C103.874 112.729 104.082 112.417 104.346 112.153C104.61 111.889 104.926 111.685 105.294 111.541C105.662 111.389 106.062 111.313 106.494 111.313C106.934 111.313 107.338 111.389 107.706 111.541C108.074 111.685 108.39 111.889 108.654 112.153C108.918 112.417 109.122 112.729 109.266 113.089C109.418 113.449 109.494 113.841 109.494 114.265ZM108.63 114.265C108.63 113.953 108.578 113.661 108.474 113.389C108.378 113.109 108.238 112.869 108.054 112.669C107.87 112.461 107.646 112.297 107.382 112.177C107.118 112.057 106.822 111.997 106.494 111.997C106.166 111.997 105.87 112.057 105.606 112.177C105.35 112.297 105.13 112.461 104.946 112.669C104.762 112.869 104.618 113.109 104.514 113.389C104.418 113.661 104.37 113.953 104.37 114.265C104.37 114.577 104.418 114.873 104.514 115.153C104.618 115.425 104.762 115.665 104.946 115.873C105.13 116.073 105.35 116.233 105.606 116.353C105.87 116.465 106.166 116.521 106.494 116.521C106.822 116.521 107.118 116.465 107.382 116.353C107.646 116.233 107.87 116.073 108.054 115.873C108.238 115.665 108.378 115.425 108.474 115.153C108.578 114.873 108.63 114.577 108.63 114.265ZM113.782 112.141H112.198V115.417C112.198 115.625 112.218 115.797 112.258 115.933C112.298 116.069 112.354 116.177 112.426 116.257C112.506 116.329 112.598 116.381 112.702 116.413C112.806 116.437 112.918 116.449 113.038 116.449C113.15 116.449 113.266 116.433 113.386 116.401C113.514 116.369 113.634 116.325 113.746 116.269L113.782 116.977C113.638 117.033 113.486 117.073 113.326 117.097C113.174 117.129 113.006 117.145 112.822 117.145C112.67 117.145 112.51 117.125 112.342 117.085C112.174 117.045 112.018 116.969 111.874 116.857C111.73 116.745 111.61 116.593 111.514 116.401C111.426 116.209 111.382 115.957 111.382 115.645V112.141H110.218V111.457H111.382V109.873H112.198V111.457H113.782V112.141ZM118.599 113.449C118.599 112.961 118.471 112.597 118.215 112.357C117.959 112.117 117.587 111.997 117.099 111.997C116.763 111.997 116.451 112.057 116.163 112.177C115.875 112.297 115.631 112.457 115.431 112.657L114.975 112.117C115.207 111.885 115.511 111.693 115.887 111.541C116.271 111.389 116.703 111.313 117.183 111.313C117.487 111.313 117.771 111.357 118.035 111.445C118.299 111.525 118.531 111.649 118.731 111.817C118.931 111.985 119.087 112.197 119.199 112.453C119.311 112.709 119.367 113.009 119.367 113.353V115.813C119.367 116.029 119.375 116.253 119.391 116.485C119.407 116.717 119.431 116.913 119.463 117.073H118.731C118.707 116.937 118.687 116.789 118.671 116.629C118.655 116.469 118.647 116.313 118.647 116.161H118.623C118.367 116.537 118.075 116.809 117.747 116.977C117.427 117.137 117.039 117.217 116.583 117.217C116.367 117.217 116.143 117.185 115.911 117.121C115.687 117.065 115.479 116.969 115.287 116.833C115.103 116.697 114.947 116.521 114.819 116.305C114.699 116.089 114.639 115.825 114.639 115.513C114.639 115.081 114.747 114.741 114.963 114.493C115.187 114.237 115.483 114.049 115.851 113.929C116.219 113.801 116.639 113.721 117.111 113.689C117.591 113.649 118.087 113.629 118.599 113.629V113.449ZM118.359 114.265C118.023 114.265 117.683 114.281 117.339 114.313C117.003 114.337 116.695 114.393 116.415 114.481C116.143 114.561 115.919 114.681 115.743 114.841C115.567 115.001 115.479 115.213 115.479 115.477C115.479 115.677 115.515 115.845 115.587 115.981C115.667 116.117 115.771 116.229 115.899 116.317C116.027 116.397 116.167 116.457 116.319 116.497C116.479 116.529 116.639 116.545 116.799 116.545C117.087 116.545 117.343 116.497 117.567 116.401C117.791 116.297 117.979 116.161 118.131 115.993C118.283 115.817 118.399 115.617 118.479 115.393C118.559 115.169 118.599 114.933 118.599 114.685V114.265H118.359ZM122.309 117.073H121.493V108.001H122.309V117.073ZM128.296 112.417C128.456 112.089 128.7 111.825 129.028 111.625C129.364 111.417 129.736 111.313 130.144 111.313C130.296 111.313 130.452 111.329 130.612 111.361C130.78 111.393 130.94 111.457 131.092 111.553C131.252 111.641 131.396 111.761 131.524 111.913C131.66 112.065 131.776 112.261 131.872 112.501C132.064 112.117 132.324 111.825 132.652 111.625C132.988 111.417 133.384 111.313 133.84 111.313C134.552 111.313 135.084 111.525 135.436 111.949C135.796 112.373 135.976 112.933 135.976 113.629V117.073H135.16V113.965C135.16 113.373 135.048 112.897 134.824 112.537C134.608 112.177 134.236 111.997 133.708 111.997C133.412 111.997 133.16 112.057 132.952 112.177C132.752 112.297 132.588 112.457 132.46 112.657C132.34 112.849 132.252 113.069 132.196 113.317C132.14 113.565 132.112 113.821 132.112 114.085V117.073H131.296V113.797C131.296 113.525 131.276 113.277 131.236 113.053C131.196 112.829 131.124 112.641 131.02 112.489C130.924 112.329 130.788 112.209 130.612 112.129C130.436 112.041 130.212 111.997 129.94 111.997C129.748 111.997 129.552 112.041 129.352 112.129C129.16 112.217 128.984 112.353 128.824 112.537C128.672 112.713 128.548 112.941 128.452 113.221C128.356 113.493 128.308 113.817 128.308 114.193V117.073H127.492V112.693C127.492 112.541 127.488 112.345 127.48 112.105C127.472 111.865 127.46 111.649 127.444 111.457H128.224C128.24 111.609 128.252 111.777 128.26 111.961C128.268 112.145 128.272 112.297 128.272 112.417H128.296ZM138.914 117.073H138.098V111.457H138.914V117.073ZM139.082 109.297C139.082 109.465 139.022 109.605 138.902 109.717C138.782 109.821 138.65 109.873 138.506 109.873C138.362 109.873 138.23 109.821 138.11 109.717C137.99 109.605 137.93 109.465 137.93 109.297C137.93 109.129 137.99 108.993 138.11 108.889C138.23 108.777 138.362 108.721 138.506 108.721C138.65 108.721 138.782 108.777 138.902 108.889C139.022 108.993 139.082 109.129 139.082 109.297ZM141.926 117.073H141.11V108.001H141.926V117.073ZM148.393 113.833C148.369 113.305 148.197 112.869 147.877 112.525C147.565 112.173 147.117 111.997 146.533 111.997C146.261 111.997 146.009 112.049 145.777 112.153C145.545 112.249 145.341 112.385 145.165 112.561C144.989 112.729 144.849 112.925 144.745 113.149C144.641 113.365 144.581 113.593 144.565 113.833H148.393ZM149.221 114.097C149.221 114.153 149.221 114.213 149.221 114.277C149.221 114.341 149.217 114.409 149.209 114.481H144.553C144.561 114.761 144.617 115.025 144.721 115.273C144.825 115.521 144.969 115.737 145.153 115.921C145.337 116.105 145.553 116.253 145.801 116.365C146.049 116.469 146.317 116.521 146.605 116.521C147.029 116.521 147.393 116.425 147.697 116.233C148.009 116.033 148.245 115.805 148.405 115.549L149.017 116.029C148.681 116.453 148.309 116.757 147.901 116.941C147.501 117.125 147.069 117.217 146.605 117.217C146.189 117.217 145.801 117.145 145.441 117.001C145.089 116.849 144.785 116.641 144.529 116.377C144.273 116.113 144.069 115.801 143.917 115.441C143.773 115.081 143.701 114.689 143.701 114.265C143.701 113.841 143.773 113.449 143.917 113.089C144.061 112.729 144.261 112.417 144.517 112.153C144.773 111.889 145.073 111.685 145.417 111.541C145.761 111.389 146.133 111.313 146.533 111.313C146.973 111.313 147.361 111.389 147.697 111.541C148.033 111.685 148.313 111.885 148.537 112.141C148.761 112.389 148.929 112.681 149.041 113.017C149.161 113.353 149.221 113.713 149.221 114.097ZM153.964 112.789C153.844 112.557 153.66 112.369 153.412 112.225C153.172 112.073 152.896 111.997 152.584 111.997C152.44 111.997 152.296 112.013 152.152 112.045C152.008 112.077 151.88 112.129 151.768 112.201C151.656 112.273 151.564 112.365 151.492 112.477C151.428 112.589 151.396 112.721 151.396 112.873C151.396 113.137 151.504 113.341 151.72 113.485C151.936 113.621 152.276 113.737 152.74 113.833C153.404 113.969 153.892 114.169 154.204 114.433C154.524 114.689 154.684 115.037 154.684 115.477C154.684 115.797 154.62 116.069 154.492 116.293C154.372 116.509 154.212 116.689 154.012 116.833C153.812 116.969 153.584 117.065 153.328 117.121C153.08 117.185 152.828 117.217 152.572 117.217C152.148 117.217 151.736 117.129 151.336 116.953C150.936 116.777 150.608 116.501 150.352 116.125L151 115.645C151.144 115.893 151.356 116.101 151.636 116.269C151.916 116.437 152.224 116.521 152.56 116.521C152.736 116.521 152.904 116.505 153.064 116.473C153.224 116.441 153.364 116.385 153.484 116.305C153.604 116.225 153.7 116.125 153.772 116.005C153.844 115.877 153.88 115.721 153.88 115.537C153.88 115.241 153.736 115.021 153.448 114.877C153.168 114.725 152.76 114.585 152.224 114.457C152.056 114.417 151.876 114.369 151.684 114.313C151.5 114.249 151.328 114.161 151.168 114.049C151.008 113.929 150.876 113.781 150.772 113.605C150.668 113.429 150.616 113.209 150.616 112.945C150.616 112.657 150.672 112.413 150.784 112.213C150.896 112.005 151.044 111.837 151.228 111.709C151.42 111.573 151.636 111.473 151.876 111.409C152.116 111.345 152.364 111.313 152.62 111.313C153.012 111.313 153.392 111.401 153.76 111.577C154.128 111.753 154.404 112.001 154.588 112.321L153.964 112.789Z",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 188,
    height: 27,
    transform: "translate(32.6016 126.573)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.5766 144.073H40.7126V136.345H37.8686V135.577H44.4206V136.345H41.5766V144.073ZM50.0799 141.265C50.0799 141.689 50.0039 142.081 49.8519 142.441C49.7079 142.801 49.5039 143.113 49.2399 143.377C48.9759 143.641 48.6599 143.849 48.2919 144.001C47.9239 144.145 47.5199 144.217 47.0799 144.217C46.6479 144.217 46.2479 144.145 45.8799 144.001C45.5119 143.849 45.1959 143.641 44.9319 143.377C44.6679 143.113 44.4599 142.801 44.3079 142.441C44.1639 142.081 44.0919 141.689 44.0919 141.265C44.0919 140.841 44.1639 140.449 44.3079 140.089C44.4599 139.729 44.6679 139.417 44.9319 139.153C45.1959 138.889 45.5119 138.685 45.8799 138.541C46.2479 138.389 46.6479 138.313 47.0799 138.313C47.5199 138.313 47.9239 138.389 48.2919 138.541C48.6599 138.685 48.9759 138.889 49.2399 139.153C49.5039 139.417 49.7079 139.729 49.8519 140.089C50.0039 140.449 50.0799 140.841 50.0799 141.265ZM49.2159 141.265C49.2159 140.953 49.1639 140.661 49.0599 140.389C48.9639 140.109 48.8239 139.869 48.6399 139.669C48.4559 139.461 48.2319 139.297 47.9679 139.177C47.7039 139.057 47.4079 138.997 47.0799 138.997C46.7519 138.997 46.4559 139.057 46.1919 139.177C45.9359 139.297 45.7159 139.461 45.5319 139.669C45.3479 139.869 45.2039 140.109 45.0999 140.389C45.0039 140.661 44.9559 140.953 44.9559 141.265C44.9559 141.577 45.0039 141.873 45.0999 142.153C45.2039 142.425 45.3479 142.665 45.5319 142.873C45.7159 143.073 45.9359 143.233 46.1919 143.353C46.4559 143.465 46.7519 143.521 47.0799 143.521C47.4079 143.521 47.7039 143.465 47.9679 143.353C48.2319 143.233 48.4559 143.073 48.6399 142.873C48.8239 142.665 48.9639 142.425 49.0599 142.153C49.1639 141.873 49.2159 141.577 49.2159 141.265ZM54.3679 139.141H52.7839V142.417C52.7839 142.625 52.8039 142.797 52.8439 142.933C52.8839 143.069 52.9399 143.177 53.0119 143.257C53.0919 143.329 53.1839 143.381 53.2879 143.413C53.3919 143.437 53.5039 143.449 53.6239 143.449C53.7359 143.449 53.8519 143.433 53.9719 143.401C54.0999 143.369 54.2199 143.325 54.3319 143.269L54.3679 143.977C54.2239 144.033 54.0719 144.073 53.9119 144.097C53.7599 144.129 53.5919 144.145 53.4079 144.145C53.2559 144.145 53.0959 144.125 52.9279 144.085C52.7599 144.045 52.6039 143.969 52.4599 143.857C52.3159 143.745 52.1959 143.593 52.0999 143.401C52.0119 143.209 51.9679 142.957 51.9679 142.645V139.141H50.8039V138.457H51.9679V136.873H52.7839V138.457H54.3679V139.141ZM59.1845 140.449C59.1845 139.961 59.0565 139.597 58.8005 139.357C58.5445 139.117 58.1725 138.997 57.6845 138.997C57.3485 138.997 57.0365 139.057 56.7485 139.177C56.4605 139.297 56.2165 139.457 56.0165 139.657L55.5605 139.117C55.7925 138.885 56.0965 138.693 56.4725 138.541C56.8565 138.389 57.2885 138.313 57.7685 138.313C58.0725 138.313 58.3565 138.357 58.6205 138.445C58.8845 138.525 59.1165 138.649 59.3165 138.817C59.5165 138.985 59.6725 139.197 59.7845 139.453C59.8965 139.709 59.9525 140.009 59.9525 140.353V142.813C59.9525 143.029 59.9605 143.253 59.9765 143.485C59.9925 143.717 60.0165 143.913 60.0485 144.073H59.3165C59.2925 143.937 59.2725 143.789 59.2565 143.629C59.2405 143.469 59.2325 143.313 59.2325 143.161H59.2085C58.9525 143.537 58.6605 143.809 58.3325 143.977C58.0125 144.137 57.6245 144.217 57.1685 144.217C56.9525 144.217 56.7285 144.185 56.4965 144.121C56.2725 144.065 56.0645 143.969 55.8725 143.833C55.6885 143.697 55.5325 143.521 55.4045 143.305C55.2845 143.089 55.2245 142.825 55.2245 142.513C55.2245 142.081 55.3325 141.741 55.5485 141.493C55.7725 141.237 56.0685 141.049 56.4365 140.929C56.8045 140.801 57.2245 140.721 57.6965 140.689C58.1765 140.649 58.6725 140.629 59.1845 140.629V140.449ZM58.9445 141.265C58.6085 141.265 58.2685 141.281 57.9245 141.313C57.5885 141.337 57.2805 141.393 57.0005 141.481C56.7285 141.561 56.5045 141.681 56.3285 141.841C56.1525 142.001 56.0645 142.213 56.0645 142.477C56.0645 142.677 56.1005 142.845 56.1725 142.981C56.2525 143.117 56.3565 143.229 56.4845 143.317C56.6125 143.397 56.7525 143.457 56.9045 143.497C57.0645 143.529 57.2245 143.545 57.3845 143.545C57.6725 143.545 57.9285 143.497 58.1525 143.401C58.3765 143.297 58.5645 143.161 58.7165 142.993C58.8685 142.817 58.9845 142.617 59.0645 142.393C59.1445 142.169 59.1845 141.933 59.1845 141.685V141.265H58.9445ZM62.8946 144.073H62.0786V135.001H62.8946V144.073ZM68.882 139.417C69.042 139.089 69.286 138.825 69.614 138.625C69.95 138.417 70.322 138.313 70.73 138.313C70.882 138.313 71.038 138.329 71.198 138.361C71.366 138.393 71.526 138.457 71.678 138.553C71.838 138.641 71.982 138.761 72.11 138.913C72.246 139.065 72.362 139.261 72.458 139.501C72.65 139.117 72.91 138.825 73.238 138.625C73.574 138.417 73.97 138.313 74.426 138.313C75.138 138.313 75.67 138.525 76.022 138.949C76.382 139.373 76.562 139.933 76.562 140.629V144.073H75.746V140.965C75.746 140.373 75.634 139.897 75.41 139.537C75.194 139.177 74.822 138.997 74.294 138.997C73.998 138.997 73.746 139.057 73.538 139.177C73.338 139.297 73.174 139.457 73.046 139.657C72.926 139.849 72.838 140.069 72.782 140.317C72.726 140.565 72.698 140.821 72.698 141.085V144.073H71.882V140.797C71.882 140.525 71.862 140.277 71.822 140.053C71.782 139.829 71.71 139.641 71.606 139.489C71.51 139.329 71.374 139.209 71.198 139.129C71.022 139.041 70.798 138.997 70.526 138.997C70.334 138.997 70.138 139.041 69.938 139.129C69.746 139.217 69.57 139.353 69.41 139.537C69.258 139.713 69.134 139.941 69.038 140.221C68.942 140.493 68.894 140.817 68.894 141.193V144.073H68.078V139.693C68.078 139.541 68.074 139.345 68.066 139.105C68.058 138.865 68.046 138.649 68.03 138.457H68.81C68.826 138.609 68.838 138.777 68.846 138.961C68.854 139.145 68.858 139.297 68.858 139.417H68.882ZM79.4998 144.073H78.6838V138.457H79.4998V144.073ZM79.6678 136.297C79.6678 136.465 79.6078 136.605 79.4878 136.717C79.3678 136.821 79.2358 136.873 79.0918 136.873C78.9478 136.873 78.8158 136.821 78.6958 136.717C78.5758 136.605 78.5158 136.465 78.5158 136.297C78.5158 136.129 78.5758 135.993 78.6958 135.889C78.8158 135.777 78.9478 135.721 79.0918 135.721C79.2358 135.721 79.3678 135.777 79.4878 135.889C79.6078 135.993 79.6678 136.129 79.6678 136.297ZM82.5118 144.073H81.6958V135.001H82.5118V144.073ZM88.9792 140.833C88.9552 140.305 88.7832 139.869 88.4632 139.525C88.1512 139.173 87.7032 138.997 87.1192 138.997C86.8472 138.997 86.5952 139.049 86.3632 139.153C86.1312 139.249 85.9272 139.385 85.7512 139.561C85.5752 139.729 85.4352 139.925 85.3312 140.149C85.2272 140.365 85.1672 140.593 85.1512 140.833H88.9792ZM89.8072 141.097C89.8072 141.153 89.8072 141.213 89.8072 141.277C89.8072 141.341 89.8032 141.409 89.7952 141.481H85.1392C85.1472 141.761 85.2032 142.025 85.3072 142.273C85.4112 142.521 85.5552 142.737 85.7392 142.921C85.9232 143.105 86.1392 143.253 86.3872 143.365C86.6352 143.469 86.9032 143.521 87.1912 143.521C87.6152 143.521 87.9792 143.425 88.2832 143.233C88.5952 143.033 88.8312 142.805 88.9912 142.549L89.6032 143.029C89.2672 143.453 88.8952 143.757 88.4872 143.941C88.0872 144.125 87.6552 144.217 87.1912 144.217C86.7752 144.217 86.3872 144.145 86.0272 144.001C85.6752 143.849 85.3712 143.641 85.1152 143.377C84.8592 143.113 84.6552 142.801 84.5032 142.441C84.3592 142.081 84.2872 141.689 84.2872 141.265C84.2872 140.841 84.3592 140.449 84.5032 140.089C84.6472 139.729 84.8472 139.417 85.1032 139.153C85.3592 138.889 85.6592 138.685 86.0032 138.541C86.3472 138.389 86.7192 138.313 87.1192 138.313C87.5592 138.313 87.9472 138.389 88.2832 138.541C88.6192 138.685 88.8992 138.885 89.1232 139.141C89.3472 139.389 89.5152 139.681 89.6272 140.017C89.7472 140.353 89.8072 140.713 89.8072 141.097ZM95.0321 140.449C95.0321 139.961 94.9041 139.597 94.6481 139.357C94.3921 139.117 94.0201 138.997 93.5321 138.997C93.1961 138.997 92.8841 139.057 92.5961 139.177C92.3081 139.297 92.0641 139.457 91.8641 139.657L91.4081 139.117C91.6401 138.885 91.9441 138.693 92.3201 138.541C92.7041 138.389 93.1361 138.313 93.6161 138.313C93.9201 138.313 94.2041 138.357 94.4681 138.445C94.7321 138.525 94.9641 138.649 95.1641 138.817C95.3641 138.985 95.5201 139.197 95.6321 139.453C95.7441 139.709 95.8001 140.009 95.8001 140.353V142.813C95.8001 143.029 95.8081 143.253 95.8241 143.485C95.8401 143.717 95.8641 143.913 95.8961 144.073H95.1641C95.1401 143.937 95.1201 143.789 95.1041 143.629C95.0881 143.469 95.0801 143.313 95.0801 143.161H95.0561C94.8001 143.537 94.5081 143.809 94.1801 143.977C93.8601 144.137 93.4721 144.217 93.0161 144.217C92.8001 144.217 92.5761 144.185 92.3441 144.121C92.1201 144.065 91.9121 143.969 91.7201 143.833C91.5361 143.697 91.3801 143.521 91.2521 143.305C91.1321 143.089 91.0721 142.825 91.0721 142.513C91.0721 142.081 91.1801 141.741 91.3961 141.493C91.6201 141.237 91.9161 141.049 92.2841 140.929C92.6521 140.801 93.0721 140.721 93.5441 140.689C94.0241 140.649 94.5201 140.629 95.0321 140.629V140.449ZM94.7921 141.265C94.4561 141.265 94.1161 141.281 93.7721 141.313C93.4361 141.337 93.1281 141.393 92.8481 141.481C92.5761 141.561 92.3521 141.681 92.1761 141.841C92.0001 142.001 91.9121 142.213 91.9121 142.477C91.9121 142.677 91.9481 142.845 92.0201 142.981C92.1001 143.117 92.2041 143.229 92.3321 143.317C92.4601 143.397 92.6001 143.457 92.7521 143.497C92.9121 143.529 93.0721 143.545 93.2321 143.545C93.5201 143.545 93.7761 143.497 94.0001 143.401C94.2241 143.297 94.4121 143.161 94.5641 142.993C94.7161 142.817 94.8321 142.617 94.9121 142.393C94.9921 142.169 95.0321 141.933 95.0321 141.685V141.265H94.7921ZM98.2023 145.201C98.4263 145.489 98.7303 145.733 99.1143 145.933C99.5063 146.133 99.9183 146.233 100.35 146.233C100.75 146.233 101.09 146.173 101.37 146.053C101.65 145.941 101.874 145.785 102.042 145.585C102.218 145.385 102.346 145.149 102.426 144.877C102.506 144.613 102.546 144.329 102.546 144.025V142.969H102.522C102.306 143.321 101.998 143.593 101.598 143.785C101.206 143.977 100.806 144.073 100.398 144.073C99.9583 144.073 99.5583 144.001 99.1983 143.857C98.8463 143.713 98.5423 143.517 98.2863 143.269C98.0383 143.013 97.8423 142.709 97.6983 142.357C97.5623 142.005 97.4943 141.625 97.4943 141.217C97.4943 140.817 97.5623 140.441 97.6983 140.089C97.8423 139.737 98.0383 139.429 98.2863 139.165C98.5423 138.901 98.8463 138.693 99.1983 138.541C99.5583 138.389 99.9583 138.313 100.398 138.313C100.806 138.313 101.206 138.409 101.598 138.601C101.99 138.793 102.298 139.069 102.522 139.429H102.546V138.457H103.362V144.025C103.362 144.329 103.318 144.653 103.23 144.997C103.15 145.341 102.994 145.657 102.762 145.945C102.538 146.233 102.23 146.473 101.838 146.665C101.446 146.857 100.938 146.953 100.314 146.953C99.7943 146.953 99.2983 146.853 98.8263 146.653C98.3543 146.453 97.9503 146.177 97.6143 145.825L98.2023 145.201ZM98.3583 141.193C98.3583 141.489 98.4063 141.769 98.5023 142.033C98.5983 142.297 98.7343 142.529 98.9103 142.729C99.0943 142.929 99.3183 143.089 99.5823 143.209C99.8463 143.321 100.146 143.377 100.482 143.377C100.794 143.377 101.082 143.325 101.346 143.221C101.61 143.117 101.838 142.969 102.03 142.777C102.222 142.585 102.37 142.357 102.474 142.093C102.586 141.821 102.642 141.521 102.642 141.193C102.642 140.897 102.586 140.617 102.474 140.353C102.37 140.089 102.222 139.857 102.03 139.657C101.838 139.457 101.61 139.297 101.346 139.177C101.082 139.057 100.794 138.997 100.482 138.997C100.146 138.997 99.8463 139.057 99.5823 139.177C99.3183 139.297 99.0943 139.457 98.9103 139.657C98.7343 139.857 98.5983 140.089 98.5023 140.353C98.4063 140.617 98.3583 140.897 98.3583 141.193ZM109.768 140.833C109.744 140.305 109.572 139.869 109.252 139.525C108.94 139.173 108.492 138.997 107.908 138.997C107.636 138.997 107.384 139.049 107.152 139.153C106.92 139.249 106.716 139.385 106.54 139.561C106.364 139.729 106.224 139.925 106.12 140.149C106.016 140.365 105.956 140.593 105.94 140.833H109.768ZM110.596 141.097C110.596 141.153 110.596 141.213 110.596 141.277C110.596 141.341 110.592 141.409 110.584 141.481H105.928C105.936 141.761 105.992 142.025 106.096 142.273C106.2 142.521 106.344 142.737 106.528 142.921C106.712 143.105 106.928 143.253 107.176 143.365C107.424 143.469 107.692 143.521 107.98 143.521C108.404 143.521 108.768 143.425 109.072 143.233C109.384 143.033 109.62 142.805 109.78 142.549L110.392 143.029C110.056 143.453 109.684 143.757 109.276 143.941C108.876 144.125 108.444 144.217 107.98 144.217C107.564 144.217 107.176 144.145 106.816 144.001C106.464 143.849 106.16 143.641 105.904 143.377C105.648 143.113 105.444 142.801 105.292 142.441C105.148 142.081 105.076 141.689 105.076 141.265C105.076 140.841 105.148 140.449 105.292 140.089C105.436 139.729 105.636 139.417 105.892 139.153C106.148 138.889 106.448 138.685 106.792 138.541C107.136 138.389 107.508 138.313 107.908 138.313C108.348 138.313 108.736 138.389 109.072 138.541C109.408 138.685 109.688 138.885 109.912 139.141C110.136 139.389 110.304 139.681 110.416 140.017C110.536 140.353 110.596 140.713 110.596 141.097ZM117.655 144.073H116.755L114.463 138.457H115.375L117.199 143.209H117.223L119.059 138.457H119.935L117.655 144.073ZM124.751 140.449C124.751 139.961 124.623 139.597 124.367 139.357C124.111 139.117 123.739 138.997 123.251 138.997C122.915 138.997 122.603 139.057 122.315 139.177C122.027 139.297 121.783 139.457 121.583 139.657L121.127 139.117C121.359 138.885 121.663 138.693 122.039 138.541C122.423 138.389 122.855 138.313 123.335 138.313C123.639 138.313 123.923 138.357 124.187 138.445C124.451 138.525 124.683 138.649 124.883 138.817C125.083 138.985 125.239 139.197 125.351 139.453C125.463 139.709 125.519 140.009 125.519 140.353V142.813C125.519 143.029 125.527 143.253 125.543 143.485C125.559 143.717 125.583 143.913 125.615 144.073H124.883C124.859 143.937 124.839 143.789 124.823 143.629C124.807 143.469 124.799 143.313 124.799 143.161H124.775C124.519 143.537 124.227 143.809 123.899 143.977C123.579 144.137 123.191 144.217 122.735 144.217C122.519 144.217 122.295 144.185 122.063 144.121C121.839 144.065 121.631 143.969 121.439 143.833C121.255 143.697 121.099 143.521 120.971 143.305C120.851 143.089 120.791 142.825 120.791 142.513C120.791 142.081 120.899 141.741 121.115 141.493C121.339 141.237 121.635 141.049 122.003 140.929C122.371 140.801 122.791 140.721 123.263 140.689C123.743 140.649 124.239 140.629 124.751 140.629V140.449ZM124.511 141.265C124.175 141.265 123.835 141.281 123.491 141.313C123.155 141.337 122.847 141.393 122.567 141.481C122.295 141.561 122.071 141.681 121.895 141.841C121.719 142.001 121.631 142.213 121.631 142.477C121.631 142.677 121.667 142.845 121.739 142.981C121.819 143.117 121.923 143.229 122.051 143.317C122.179 143.397 122.319 143.457 122.471 143.497C122.631 143.529 122.791 143.545 122.951 143.545C123.239 143.545 123.495 143.497 123.719 143.401C123.943 143.297 124.131 143.161 124.283 142.993C124.435 142.817 124.551 142.617 124.631 142.393C124.711 142.169 124.751 141.933 124.751 141.685V141.265H124.511ZM128.461 144.073H127.645V135.001H128.461V144.073ZM134.724 144.073C134.708 143.921 134.696 143.753 134.688 143.569C134.68 143.385 134.676 143.233 134.676 143.113H134.652C134.492 143.441 134.232 143.709 133.872 143.917C133.512 144.117 133.132 144.217 132.732 144.217C132.02 144.217 131.484 144.005 131.124 143.581C130.772 143.157 130.596 142.597 130.596 141.901V138.457H131.412V141.565C131.412 141.861 131.436 142.129 131.484 142.369C131.532 142.609 131.612 142.817 131.724 142.993C131.844 143.161 132 143.293 132.192 143.389C132.392 143.485 132.64 143.533 132.936 143.533C133.152 143.533 133.36 143.489 133.56 143.401C133.768 143.313 133.952 143.181 134.112 143.005C134.272 142.821 134.4 142.593 134.496 142.321C134.592 142.041 134.64 141.713 134.64 141.337V138.457H135.456V142.837C135.456 142.989 135.46 143.185 135.468 143.425C135.476 143.665 135.488 143.881 135.504 144.073H134.724ZM141.901 140.833C141.877 140.305 141.705 139.869 141.385 139.525C141.073 139.173 140.625 138.997 140.041 138.997C139.769 138.997 139.517 139.049 139.285 139.153C139.053 139.249 138.849 139.385 138.673 139.561C138.497 139.729 138.357 139.925 138.253 140.149C138.149 140.365 138.089 140.593 138.073 140.833H141.901ZM142.729 141.097C142.729 141.153 142.729 141.213 142.729 141.277C142.729 141.341 142.725 141.409 142.717 141.481H138.061C138.069 141.761 138.125 142.025 138.229 142.273C138.333 142.521 138.477 142.737 138.661 142.921C138.845 143.105 139.061 143.253 139.309 143.365C139.557 143.469 139.825 143.521 140.113 143.521C140.537 143.521 140.901 143.425 141.205 143.233C141.517 143.033 141.753 142.805 141.913 142.549L142.525 143.029C142.189 143.453 141.817 143.757 141.409 143.941C141.009 144.125 140.577 144.217 140.113 144.217C139.697 144.217 139.309 144.145 138.949 144.001C138.597 143.849 138.293 143.641 138.037 143.377C137.781 143.113 137.577 142.801 137.425 142.441C137.281 142.081 137.209 141.689 137.209 141.265C137.209 140.841 137.281 140.449 137.425 140.089C137.569 139.729 137.769 139.417 138.025 139.153C138.281 138.889 138.581 138.685 138.925 138.541C139.269 138.389 139.641 138.313 140.041 138.313C140.481 138.313 140.869 138.389 141.205 138.541C141.541 138.685 141.821 138.885 142.045 139.141C142.269 139.389 142.437 139.681 142.549 140.017C142.669 140.353 142.729 140.713 142.729 141.097Z",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 188,
    height: 27,
    transform: "translate(32.6016 153.573)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.5766 171.073H40.7126V163.345H37.8686V162.577H44.4206V163.345H41.5766V171.073ZM50.0799 168.265C50.0799 168.689 50.0039 169.081 49.8519 169.441C49.7079 169.801 49.5039 170.113 49.2399 170.377C48.9759 170.641 48.6599 170.849 48.2919 171.001C47.9239 171.145 47.5199 171.217 47.0799 171.217C46.6479 171.217 46.2479 171.145 45.8799 171.001C45.5119 170.849 45.1959 170.641 44.9319 170.377C44.6679 170.113 44.4599 169.801 44.3079 169.441C44.1639 169.081 44.0919 168.689 44.0919 168.265C44.0919 167.841 44.1639 167.449 44.3079 167.089C44.4599 166.729 44.6679 166.417 44.9319 166.153C45.1959 165.889 45.5119 165.685 45.8799 165.541C46.2479 165.389 46.6479 165.313 47.0799 165.313C47.5199 165.313 47.9239 165.389 48.2919 165.541C48.6599 165.685 48.9759 165.889 49.2399 166.153C49.5039 166.417 49.7079 166.729 49.8519 167.089C50.0039 167.449 50.0799 167.841 50.0799 168.265ZM49.2159 168.265C49.2159 167.953 49.1639 167.661 49.0599 167.389C48.9639 167.109 48.8239 166.869 48.6399 166.669C48.4559 166.461 48.2319 166.297 47.9679 166.177C47.7039 166.057 47.4079 165.997 47.0799 165.997C46.7519 165.997 46.4559 166.057 46.1919 166.177C45.9359 166.297 45.7159 166.461 45.5319 166.669C45.3479 166.869 45.2039 167.109 45.0999 167.389C45.0039 167.661 44.9559 167.953 44.9559 168.265C44.9559 168.577 45.0039 168.873 45.0999 169.153C45.2039 169.425 45.3479 169.665 45.5319 169.873C45.7159 170.073 45.9359 170.233 46.1919 170.353C46.4559 170.465 46.7519 170.521 47.0799 170.521C47.4079 170.521 47.7039 170.465 47.9679 170.353C48.2319 170.233 48.4559 170.073 48.6399 169.873C48.8239 169.665 48.9639 169.425 49.0599 169.153C49.1639 168.873 49.2159 168.577 49.2159 168.265ZM54.3679 166.141H52.7839V169.417C52.7839 169.625 52.8039 169.797 52.8439 169.933C52.8839 170.069 52.9399 170.177 53.0119 170.257C53.0919 170.329 53.1839 170.381 53.2879 170.413C53.3919 170.437 53.5039 170.449 53.6239 170.449C53.7359 170.449 53.8519 170.433 53.9719 170.401C54.0999 170.369 54.2199 170.325 54.3319 170.269L54.3679 170.977C54.2239 171.033 54.0719 171.073 53.9119 171.097C53.7599 171.129 53.5919 171.145 53.4079 171.145C53.2559 171.145 53.0959 171.125 52.9279 171.085C52.7599 171.045 52.6039 170.969 52.4599 170.857C52.3159 170.745 52.1959 170.593 52.0999 170.401C52.0119 170.209 51.9679 169.957 51.9679 169.645V166.141H50.8039V165.457H51.9679V163.873H52.7839V165.457H54.3679V166.141ZM59.1845 167.449C59.1845 166.961 59.0565 166.597 58.8005 166.357C58.5445 166.117 58.1725 165.997 57.6845 165.997C57.3485 165.997 57.0365 166.057 56.7485 166.177C56.4605 166.297 56.2165 166.457 56.0165 166.657L55.5605 166.117C55.7925 165.885 56.0965 165.693 56.4725 165.541C56.8565 165.389 57.2885 165.313 57.7685 165.313C58.0725 165.313 58.3565 165.357 58.6205 165.445C58.8845 165.525 59.1165 165.649 59.3165 165.817C59.5165 165.985 59.6725 166.197 59.7845 166.453C59.8965 166.709 59.9525 167.009 59.9525 167.353V169.813C59.9525 170.029 59.9605 170.253 59.9765 170.485C59.9925 170.717 60.0165 170.913 60.0485 171.073H59.3165C59.2925 170.937 59.2725 170.789 59.2565 170.629C59.2405 170.469 59.2325 170.313 59.2325 170.161H59.2085C58.9525 170.537 58.6605 170.809 58.3325 170.977C58.0125 171.137 57.6245 171.217 57.1685 171.217C56.9525 171.217 56.7285 171.185 56.4965 171.121C56.2725 171.065 56.0645 170.969 55.8725 170.833C55.6885 170.697 55.5325 170.521 55.4045 170.305C55.2845 170.089 55.2245 169.825 55.2245 169.513C55.2245 169.081 55.3325 168.741 55.5485 168.493C55.7725 168.237 56.0685 168.049 56.4365 167.929C56.8045 167.801 57.2245 167.721 57.6965 167.689C58.1765 167.649 58.6725 167.629 59.1845 167.629V167.449ZM58.9445 168.265C58.6085 168.265 58.2685 168.281 57.9245 168.313C57.5885 168.337 57.2805 168.393 57.0005 168.481C56.7285 168.561 56.5045 168.681 56.3285 168.841C56.1525 169.001 56.0645 169.213 56.0645 169.477C56.0645 169.677 56.1005 169.845 56.1725 169.981C56.2525 170.117 56.3565 170.229 56.4845 170.317C56.6125 170.397 56.7525 170.457 56.9045 170.497C57.0645 170.529 57.2245 170.545 57.3845 170.545C57.6725 170.545 57.9285 170.497 58.1525 170.401C58.3765 170.297 58.5645 170.161 58.7165 169.993C58.8685 169.817 58.9845 169.617 59.0645 169.393C59.1445 169.169 59.1845 168.933 59.1845 168.685V168.265H58.9445ZM62.8946 171.073H62.0786V162.001H62.8946V171.073ZM68.078 166.693C68.078 166.541 68.074 166.345 68.066 166.105C68.058 165.865 68.046 165.649 68.03 165.457H68.81C68.826 165.609 68.838 165.777 68.846 165.961C68.854 166.145 68.858 166.297 68.858 166.417H68.882C69.042 166.089 69.282 165.825 69.602 165.625C69.922 165.417 70.282 165.313 70.682 165.313C70.786 165.313 70.878 165.317 70.958 165.325C71.046 165.333 71.134 165.349 71.222 165.373L71.114 166.141C71.066 166.125 70.986 166.109 70.874 166.093C70.762 166.077 70.65 166.069 70.538 166.069C70.322 166.069 70.114 166.109 69.914 166.189C69.714 166.269 69.538 166.397 69.386 166.573C69.242 166.741 69.122 166.961 69.026 167.233C68.938 167.497 68.894 167.817 68.894 168.193V171.073H68.078V166.693ZM76.4753 167.833C76.4513 167.305 76.2793 166.869 75.9593 166.525C75.6473 166.173 75.1993 165.997 74.6153 165.997C74.3433 165.997 74.0913 166.049 73.8593 166.153C73.6273 166.249 73.4233 166.385 73.2473 166.561C73.0713 166.729 72.9313 166.925 72.8273 167.149C72.7233 167.365 72.6633 167.593 72.6473 167.833H76.4753ZM77.3033 168.097C77.3033 168.153 77.3033 168.213 77.3033 168.277C77.3033 168.341 77.2993 168.409 77.2913 168.481H72.6353C72.6433 168.761 72.6993 169.025 72.8033 169.273C72.9073 169.521 73.0513 169.737 73.2353 169.921C73.4193 170.105 73.6353 170.253 73.8833 170.365C74.1313 170.469 74.3993 170.521 74.6873 170.521C75.1113 170.521 75.4753 170.425 75.7793 170.233C76.0913 170.033 76.3273 169.805 76.4873 169.549L77.0993 170.029C76.7633 170.453 76.3913 170.757 75.9833 170.941C75.5833 171.125 75.1513 171.217 74.6873 171.217C74.2713 171.217 73.8833 171.145 73.5233 171.001C73.1713 170.849 72.8673 170.641 72.6113 170.377C72.3553 170.113 72.1513 169.801 71.9993 169.441C71.8553 169.081 71.7833 168.689 71.7833 168.265C71.7833 167.841 71.8553 167.449 71.9993 167.089C72.1433 166.729 72.3433 166.417 72.5993 166.153C72.8553 165.889 73.1553 165.685 73.4993 165.541C73.8433 165.389 74.2153 165.313 74.6153 165.313C75.0553 165.313 75.4433 165.389 75.7793 165.541C76.1153 165.685 76.3953 165.885 76.6193 166.141C76.8433 166.389 77.0113 166.681 77.1233 167.017C77.2433 167.353 77.3033 167.713 77.3033 168.097ZM79.8745 173.953H79.0585V165.457H79.8745V166.429H79.9105C80.1425 166.061 80.4505 165.785 80.8345 165.601C81.2265 165.409 81.6225 165.313 82.0225 165.313C82.4625 165.313 82.8585 165.389 83.2105 165.541C83.5705 165.693 83.8745 165.901 84.1225 166.165C84.3785 166.429 84.5745 166.741 84.7105 167.101C84.8545 167.461 84.9265 167.849 84.9265 168.265C84.9265 168.681 84.8545 169.069 84.7105 169.429C84.5745 169.789 84.3785 170.101 84.1225 170.365C83.8745 170.629 83.5705 170.837 83.2105 170.989C82.8585 171.141 82.4625 171.217 82.0225 171.217C81.6225 171.217 81.2265 171.125 80.8345 170.941C80.4505 170.749 80.1425 170.477 79.9105 170.125H79.8745V173.953ZM84.0625 168.265C84.0625 167.953 84.0145 167.661 83.9185 167.389C83.8225 167.109 83.6825 166.869 83.4985 166.669C83.3225 166.461 83.1025 166.297 82.8385 166.177C82.5745 166.057 82.2745 165.997 81.9385 165.997C81.6265 165.997 81.3385 166.057 81.0745 166.177C80.8105 166.289 80.5825 166.449 80.3905 166.657C80.1985 166.857 80.0465 167.097 79.9345 167.377C79.8305 167.649 79.7785 167.945 79.7785 168.265C79.7785 168.585 79.8305 168.885 79.9345 169.165C80.0465 169.437 80.1985 169.673 80.3905 169.873C80.5825 170.073 80.8105 170.233 81.0745 170.353C81.3385 170.465 81.6265 170.521 81.9385 170.521C82.2745 170.521 82.5745 170.465 82.8385 170.353C83.1025 170.233 83.3225 170.073 83.4985 169.873C83.6825 169.665 83.8225 169.425 83.9185 169.153C84.0145 168.873 84.0625 168.577 84.0625 168.265ZM92.2557 168.265C92.2557 168.689 92.1797 169.081 92.0277 169.441C91.8837 169.801 91.6797 170.113 91.4157 170.377C91.1517 170.641 90.8357 170.849 90.4677 171.001C90.0997 171.145 89.6957 171.217 89.2557 171.217C88.8237 171.217 88.4237 171.145 88.0557 171.001C87.6877 170.849 87.3717 170.641 87.1077 170.377C86.8437 170.113 86.6357 169.801 86.4837 169.441C86.3397 169.081 86.2677 168.689 86.2677 168.265C86.2677 167.841 86.3397 167.449 86.4837 167.089C86.6357 166.729 86.8437 166.417 87.1077 166.153C87.3717 165.889 87.6877 165.685 88.0557 165.541C88.4237 165.389 88.8237 165.313 89.2557 165.313C89.6957 165.313 90.0997 165.389 90.4677 165.541C90.8357 165.685 91.1517 165.889 91.4157 166.153C91.6797 166.417 91.8837 166.729 92.0277 167.089C92.1797 167.449 92.2557 167.841 92.2557 168.265ZM91.3917 168.265C91.3917 167.953 91.3397 167.661 91.2357 167.389C91.1397 167.109 90.9997 166.869 90.8157 166.669C90.6317 166.461 90.4077 166.297 90.1437 166.177C89.8797 166.057 89.5837 165.997 89.2557 165.997C88.9277 165.997 88.6317 166.057 88.3677 166.177C88.1117 166.297 87.8917 166.461 87.7077 166.669C87.5237 166.869 87.3797 167.109 87.2757 167.389C87.1797 167.661 87.1317 167.953 87.1317 168.265C87.1317 168.577 87.1797 168.873 87.2757 169.153C87.3797 169.425 87.5237 169.665 87.7077 169.873C87.8917 170.073 88.1117 170.233 88.3677 170.353C88.6317 170.465 88.9277 170.521 89.2557 170.521C89.5837 170.521 89.8797 170.465 90.1437 170.353C90.4077 170.233 90.6317 170.073 90.8157 169.873C90.9997 169.665 91.1397 169.425 91.2357 169.153C91.3397 168.873 91.3917 168.577 91.3917 168.265ZM94.0116 166.693C94.0116 166.541 94.0076 166.345 93.9996 166.105C93.9916 165.865 93.9796 165.649 93.9636 165.457H94.7436C94.7596 165.609 94.7716 165.777 94.7796 165.961C94.7876 166.145 94.7916 166.297 94.7916 166.417H94.8156C94.9756 166.089 95.2156 165.825 95.5356 165.625C95.8556 165.417 96.2156 165.313 96.6156 165.313C96.7196 165.313 96.8116 165.317 96.8916 165.325C96.9796 165.333 97.0676 165.349 97.1556 165.373L97.0476 166.141C96.9996 166.125 96.9196 166.109 96.8076 166.093C96.6956 166.077 96.5836 166.069 96.4716 166.069C96.2556 166.069 96.0476 166.109 95.8476 166.189C95.6476 166.269 95.4716 166.397 95.3196 166.573C95.1756 166.741 95.0556 166.961 94.9596 167.233C94.8716 167.497 94.8276 167.817 94.8276 168.193V171.073H94.0116V166.693ZM100.727 166.141H99.1432V169.417C99.1432 169.625 99.1632 169.797 99.2032 169.933C99.2432 170.069 99.2992 170.177 99.3712 170.257C99.4512 170.329 99.5432 170.381 99.6472 170.413C99.7512 170.437 99.8632 170.449 99.9832 170.449C100.095 170.449 100.211 170.433 100.331 170.401C100.459 170.369 100.579 170.325 100.691 170.269L100.727 170.977C100.583 171.033 100.431 171.073 100.271 171.097C100.119 171.129 99.9512 171.145 99.7672 171.145C99.6152 171.145 99.4552 171.125 99.2872 171.085C99.1192 171.045 98.9632 170.969 98.8192 170.857C98.6752 170.745 98.5552 170.593 98.4592 170.401C98.3712 170.209 98.3272 169.957 98.3272 169.645V166.141H97.1632V165.457H98.3272V163.873H99.1432V165.457H100.727V166.141ZM107.308 171.073H106.408L104.116 165.457H105.028L106.852 170.209H106.876L108.712 165.457H109.588L107.308 171.073ZM114.403 167.449C114.403 166.961 114.275 166.597 114.019 166.357C113.763 166.117 113.391 165.997 112.903 165.997C112.567 165.997 112.255 166.057 111.967 166.177C111.679 166.297 111.435 166.457 111.235 166.657L110.779 166.117C111.011 165.885 111.315 165.693 111.691 165.541C112.075 165.389 112.507 165.313 112.987 165.313C113.291 165.313 113.575 165.357 113.839 165.445C114.103 165.525 114.335 165.649 114.535 165.817C114.735 165.985 114.891 166.197 115.003 166.453C115.115 166.709 115.171 167.009 115.171 167.353V169.813C115.171 170.029 115.179 170.253 115.195 170.485C115.211 170.717 115.235 170.913 115.267 171.073H114.535C114.511 170.937 114.491 170.789 114.475 170.629C114.459 170.469 114.451 170.313 114.451 170.161H114.427C114.171 170.537 113.879 170.809 113.551 170.977C113.231 171.137 112.843 171.217 112.387 171.217C112.171 171.217 111.947 171.185 111.715 171.121C111.491 171.065 111.283 170.969 111.091 170.833C110.907 170.697 110.751 170.521 110.623 170.305C110.503 170.089 110.443 169.825 110.443 169.513C110.443 169.081 110.551 168.741 110.767 168.493C110.991 168.237 111.287 168.049 111.655 167.929C112.023 167.801 112.443 167.721 112.915 167.689C113.395 167.649 113.891 167.629 114.403 167.629V167.449ZM114.163 168.265C113.827 168.265 113.487 168.281 113.143 168.313C112.807 168.337 112.499 168.393 112.219 168.481C111.947 168.561 111.723 168.681 111.547 168.841C111.371 169.001 111.283 169.213 111.283 169.477C111.283 169.677 111.319 169.845 111.391 169.981C111.471 170.117 111.575 170.229 111.703 170.317C111.831 170.397 111.971 170.457 112.123 170.497C112.283 170.529 112.443 170.545 112.603 170.545C112.891 170.545 113.147 170.497 113.371 170.401C113.595 170.297 113.783 170.161 113.935 169.993C114.087 169.817 114.203 169.617 114.283 169.393C114.363 169.169 114.403 168.933 114.403 168.685V168.265H114.163ZM118.113 171.073H117.297V162.001H118.113V171.073ZM124.377 171.073C124.361 170.921 124.349 170.753 124.341 170.569C124.333 170.385 124.329 170.233 124.329 170.113H124.305C124.145 170.441 123.885 170.709 123.525 170.917C123.165 171.117 122.785 171.217 122.385 171.217C121.673 171.217 121.137 171.005 120.777 170.581C120.425 170.157 120.249 169.597 120.249 168.901V165.457H121.065V168.565C121.065 168.861 121.089 169.129 121.137 169.369C121.185 169.609 121.265 169.817 121.377 169.993C121.497 170.161 121.653 170.293 121.845 170.389C122.045 170.485 122.293 170.533 122.589 170.533C122.805 170.533 123.013 170.489 123.213 170.401C123.421 170.313 123.605 170.181 123.765 170.005C123.925 169.821 124.053 169.593 124.149 169.321C124.245 169.041 124.293 168.713 124.293 168.337V165.457H125.109V169.837C125.109 169.989 125.113 170.185 125.121 170.425C125.129 170.665 125.141 170.881 125.157 171.073H124.377ZM131.553 167.833C131.529 167.305 131.357 166.869 131.037 166.525C130.725 166.173 130.277 165.997 129.693 165.997C129.421 165.997 129.169 166.049 128.937 166.153C128.705 166.249 128.501 166.385 128.325 166.561C128.149 166.729 128.009 166.925 127.905 167.149C127.801 167.365 127.741 167.593 127.725 167.833H131.553ZM132.381 168.097C132.381 168.153 132.381 168.213 132.381 168.277C132.381 168.341 132.377 168.409 132.369 168.481H127.713C127.721 168.761 127.777 169.025 127.881 169.273C127.985 169.521 128.129 169.737 128.313 169.921C128.497 170.105 128.713 170.253 128.961 170.365C129.209 170.469 129.477 170.521 129.765 170.521C130.189 170.521 130.553 170.425 130.857 170.233C131.169 170.033 131.405 169.805 131.565 169.549L132.177 170.029C131.841 170.453 131.469 170.757 131.061 170.941C130.661 171.125 130.229 171.217 129.765 171.217C129.349 171.217 128.961 171.145 128.601 171.001C128.249 170.849 127.945 170.641 127.689 170.377C127.433 170.113 127.229 169.801 127.077 169.441C126.933 169.081 126.861 168.689 126.861 168.265C126.861 167.841 126.933 167.449 127.077 167.089C127.221 166.729 127.421 166.417 127.677 166.153C127.933 165.889 128.233 165.685 128.577 165.541C128.921 165.389 129.293 165.313 129.693 165.313C130.133 165.313 130.521 165.389 130.857 165.541C131.193 165.685 131.473 165.885 131.697 166.141C131.921 166.389 132.089 166.681 132.201 167.017C132.321 167.353 132.381 167.713 132.381 168.097Z",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 172.056,
    y: 72.2708,
    width: 5.63157,
    height: 107,
    fill: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 173.558,
    y: 73.4497,
    width: 3.0035,
    height: 57.774,
    rx: 1.50175,
    fill: "#CCCCCC"
  }))), /*#__PURE__*/React.createElement("rect", {
    x: 102.146,
    y: 84.4036,
    width: 16,
    height: 24,
    fill: "url(#pattern0)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1420_6457",
    x: 28.1134,
    y: 68.8707,
    width: 154.066,
    height: 116.066,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.13328
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.26656
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.434375 0 0 0 0 0.466229 0 0 0 0 0.579167 0 0 0 0.23 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1420_6457"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1420_6457",
    result: "shape"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_1420_6457",
    transform: "scale(0.0034965 0.002331)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1420_6457"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.646484,
    y: 0.270508,
    width: 314,
    height: 198,
    rx: 16,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_1420_6457"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 20.9482,
    y: 13.2705,
    width: 273.397,
    height: 273.398,
    rx: 136.699,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_1420_6457"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 273.397,
    height: 7.03023,
    fill: "white",
    transform: "translate(20.9502 13.2705)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip3_1420_6457"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 273.397,
    height: 7.03023,
    fill: "white",
    transform: "translate(20.9502 20.3022)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip4_1420_6457"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 273.397,
    height: 7.03023,
    fill: "white",
    transform: "translate(20.9502 27.3308)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip5_1420_6457"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 273.397,
    height: 7.03023,
    fill: "white",
    transform: "translate(20.9502 34.3628)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip6_1420_6457"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 273.397,
    height: 7.03023,
    fill: "white",
    transform: "translate(20.9502 41.3921)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip7_1420_6457"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 273.397,
    height: 7.03023,
    fill: "white",
    transform: "translate(20.9502 48.4221)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip8_1420_6457"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 273.397,
    height: 7.03023,
    fill: "white",
    transform: "translate(20.9502 55.4529)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip9_1420_6457"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 273.397,
    height: 7.03023,
    fill: "white",
    transform: "translate(20.9502 62.4827)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip10_1420_6457"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 273.397,
    height: 7.03023,
    fill: "white",
    transform: "translate(20.9502 69.5132)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip11_1420_6457"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 273.397,
    height: 7.03023,
    fill: "white",
    transform: "translate(20.9502 76.5422)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip12_1420_6457"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 273.397,
    height: 7.03023,
    fill: "white",
    transform: "translate(20.9502 83.5728)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip13_1420_6457"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 273.397,
    height: 7.03023,
    fill: "white",
    transform: "translate(20.9502 90.603)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip14_1420_6457"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 273.397,
    height: 7.03023,
    fill: "white",
    transform: "translate(20.9502 97.6335)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip15_1420_6457"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 273.397,
    height: 7.03023,
    fill: "white",
    transform: "translate(20.9502 104.664)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip16_1420_6457"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 273.397,
    height: 7.03023,
    fill: "white",
    transform: "translate(20.9502 111.695)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip17_1420_6457"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 273.397,
    height: 7.03023,
    fill: "white",
    transform: "translate(20.9502 118.724)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip18_1420_6457"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 273.397,
    height: 7.03023,
    fill: "white",
    transform: "translate(20.9502 125.754)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip19_1420_6457"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 273.397,
    height: 7.03023,
    fill: "white",
    transform: "translate(20.9502 132.785)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip20_1420_6457"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 273.397,
    height: 7.03023,
    fill: "white",
    transform: "translate(20.9502 139.815)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip21_1420_6457"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 273.397,
    height: 7.03023,
    fill: "white",
    transform: "translate(20.9502 146.844)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip22_1420_6457"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 273.397,
    height: 7.03023,
    fill: "white",
    transform: "translate(20.9502 153.876)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip23_1420_6457"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 273.397,
    height: 7.03023,
    fill: "white",
    transform: "translate(20.9502 160.906)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip24_1420_6457"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 273.397,
    height: 7.03023,
    fill: "white",
    transform: "translate(20.9502 167.935)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip25_1420_6457"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 273.397,
    height: 7.03023,
    fill: "white",
    transform: "translate(20.9502 174.966)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip26_1420_6457"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 273.397,
    height: 7.03023,
    fill: "white",
    transform: "translate(20.9502 181.997)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip27_1420_6457"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 273.397,
    height: 7.03023,
    fill: "white",
    transform: "translate(20.9502 189.026)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip28_1420_6457"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 273.397,
    height: 7.03023,
    fill: "white",
    transform: "translate(20.9502 196.057)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip29_1420_6457"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 32.6465,
    y: 72.2705,
    width: 145,
    height: 107,
    rx: 3.26635,
    fill: "white"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_1420_6457",
    width: 286,
    height: 429,
    xlinkHref: "data:image/png;base64,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"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRules);
export default __webpack_public_path__ + "static/media/rules.82c3266183a7cec656fdd5c7d8c79c28.svg";
export { ForwardRef as ReactComponent };